/* eslint-disable max-len */
import React, {Fragment} from 'react';

export default {
    ADD_FRIEND: {
        viewBox: '0 0 46 55',
        data: (
            <g fill="none" fillRule="evenodd">
                <path
                    className="background"
                    d="M4.127 0C1.113 0 0 1.152 0 4.274v37.67c0 .354.013.682.044.986.069.682-.044 2.028 2.324 3.103 1.579.717 7.75 3.365 18.514 7.943 1.042.448 1.335.554 2.116.554.697.014 1.157-.103 2.107-.554 10.772-4.435 16.946-7.082 18.525-7.943 2.367-1.29 2.367-3.735 2.367-4.089V4.274C45.997 1.152 44.884 0 41.87 0H4.127z"
                    fill="currentColor"
                    opacity="0.1"
                />
                <path d="M9 13h24v24H9z" />
                <path
                    className="foreground"
                    d="M24 25c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
                    fill="currentColor"
                    fillRule="nonzero"
                />
            </g>
        )
    },
    ALERT: {
        viewBox: '0 0 61 71',
        data: (
            <Fragment>
                <path
                    d="M5.4677 0C1.4741 0 0 1.4943 0 5.545v48.8775c0 .459.0179.884.0578 1.2792.0914.884-.0578 2.6306 3.0795 4.026 2.0916.9304 10.267 4.3653 24.5264 10.305 1.3801.5821 1.7684.72 2.8039.72.9224.018 1.5315-.1342 2.7912-.72 14.2692-5.7532 22.4492-9.1881 24.54-10.305 3.1363-1.6751 3.1363-4.8461 3.1363-5.3052V5.5449C60.9351 1.4943 59.4611 0 55.4674 0H5.4677z"
                    fill="#0078F2"
                />
                <path
                    d="M32.6667 28.3938l-1.4 6.848h-1.9542L28 28.5787V23h4.6667v5.3938zm0 13.2729H28v-4.4948h4.6667v4.4948z"
                    fill="#FFF"
                />
            </Fragment>
        )
    },
    ARROW: {
        viewBox: '0 0 30.16 30.158',
        data: (
            <path
                d="M3316,17827.867v-12.205h2.617v7.441l16.573-16.574,2.121,2.121-16.6,16.6h7.5v2.617Z"
                transform="translate(-10231.281 14966.041) rotate(-135)"
                fill="currentColor"
            />
        )
    },
    BOOK: {
        viewBox: '0 0 16 16',
        data: (
            <Fragment>
                <path
                    fill="currentColor"
                    d="M14 2v13h-10.5c-0.829 0-1.5-0.672-1.5-1.5s0.671-1.5 1.5-1.5h9.5v-12h-10c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12v-14h-1z"
                />
                <path
                    fill="currentColor"
                    d="M3.501 13v0c-0 0-0.001 0-0.001 0-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0 0 0.001-0 0.001-0v0h9.498v-1h-9.498z"
                />
            </Fragment>
        )
    },
    CHEVRON: {
        viewBox: '0 0 7.7 12',
        data: <path fill="currentColor" d="M1.7 0L0 1.7 4.3 6 0 10.3 1.7 12l6-6z" />
    },
    CHEVRON_THIN: {
        viewBox: '0 0 5 9',
        data: <path stroke="currentColor" d="M1 1l3 3.5L1 8" fill="none" fillRule="evenodd" />
    },
    CLOSE: {
        viewBox: '0 0 14 14',
        data: (
            <path
                d="M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z"
                fill="currentColor"
                fillRule="nonzero"
            />
        )
    },
    CLOSE_THIN: {
        viewBox: '0 0 14 15',
        data: (
            <g fill="currentColor" fillRule="evenodd">
                <path d="M.98959236 14.21751442L13.71751442 1.48959236l-.70710678-.70710678L.28248558 13.51040764z" />
                <path d="M.28248558 1.48959236l12.72792206 12.72792206.70710678-.70710678L.98959236.78248558z" />
            </g>
        )
    },
    DOWNLOAD: {
        viewBox: '0 0 13 14',
        data: (
            <path
                d="M9 7.006h2.578a.5.5 0 0 1 .375.83l-5.085 5.775a.5.5 0 0 1-.733.019L.508 7.855a.5.5 0 0 1 .358-.849H4V0h5v7.006z"
                fill="currentColor"
                fillRule="evenodd"
            />
        )
    },
    EBOOK: {
        viewBox: '0 0 16 16',
        data: (
            <Fragment>
                <path
                    fill="currentColor"
                    d="M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                />
                <path
                    fill="currentColor"
                    d="M11.5 13h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                />
                <path
                    fill="currentColor"
                    d="M11.5 11h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                />
                <path
                    fill="currentColor"
                    d="M11.5 9h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                />
            </Fragment>
        )
    },
    EPIC: {
        viewBox: '0 0 88 104',
        data: (
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.896 0h72.202c5.767 0 7.896 2.178 7.896 8.081v71.232c0 .67 0 5.29-4.529 7.732-3.02 1.627-14.832 6.633-35.437 15.018-1.82.854-2.699 1.075-4.03 1.05-1.496 0-2.057-.202-4.05-1.05C19.357 93.407 7.551 88.4 4.53 87.045 0 85.01.215 82.465.083 81.177A18.781 18.781 0 0 1 0 79.313V8.081C0 2.178 2.129 0 7.896 0zm66.089 72.604L74 72.43v-.381l-.015-.174-.017-.159-.064-.318-.032-.142-.047-.143-.05-.144-.063-.126-.081-.144-.081-.126-.096-.142-.096-.128-.113-.11-.113-.128-.128-.111-.128-.111-.13-.08-.128-.096-.128-.078-.145-.08-.145-.079-.16-.08-.162-.064-.16-.08-.177-.06-.145-.049-.144-.048-.162-.046-.144-.048-.16-.048-.16-.048-.163-.032-.177-.048-.16-.046-.177-.033-.177-.047-.177-.048-.177-.048-.16-.031-.145-.048-.145-.032-.128-.048-.128-.031-.194-.063-.177-.065-.16-.063-.128-.079-.147-.08-.111-.11-.066-.095-.079-.175-.017-.206v-.033l.017-.157.064-.144.096-.143.145-.127.113-.063.128-.063.145-.032.162-.033.175-.031h.354l.145.016.162.015.16.017.16.031.16.032.162.031.16.048.162.048.176.048.13.063.144.048.128.063.145.063.129.065.145.063.128.08.145.062.13.096.127.08.144.079.13.095.096-.126.08-.128.097-.127.096-.126.096-.144.08-.126.097-.128.098-.127.079-.126.096-.128.098-.127.08-.126.095-.144.098-.126.096-.128.08-.127.097-.128-.128-.094-.128-.095-.13-.096-.128-.08-.145-.094-.128-.08-.145-.079-.145-.08-.128-.064-.145-.078-.162-.064-.144-.063-.145-.063-.144-.048-.162-.065-.144-.031-.145-.048-.161-.047-.144-.031-.161-.033-.16-.032-.146-.031-.16-.032-.177-.016-.16-.032-.178-.015h-.16l-.178-.016-.177-.017h-.69l-.321.033-.162.015-.16.017-.145.031-.16.032-.147.031-.143.032-.128.033-.147.046-.16.065-.16.046-.145.065-.145.08-.145.062-.145.08-.128.08-.128.094-.13.096-.111.08-.13.11-.111.128-.113.11-.113.127-.096.127-.096.128-.081.142-.08.143-.065.144-.064.142-.064.143-.032.142-.05.144-.063.285-.017.16-.015.142-.017.159v.366l.017.173.015.16.017.158.032.143.032.159.049.126.047.144.049.126.064.11.08.143.08.128.08.11.097.112.098.11.111.112.113.11.113.097.128.08.13.094.143.08.13.079.16.08.145.079.16.063.162.064.16.063.177.063.145.048.145.048.143.048.162.032.145.048.16.046.16.032.162.048.16.031.177.048.162.032.175.048.162.031.16.048.145.032.145.048.128.031.113.032.193.079.161.065.145.063.128.063.129.096.112.094.081.111.064.159.017.19v.032l-.017.159-.048.142-.064.128-.097.11-.128.097-.113.063-.13.048-.143.031-.145.032-.161.031-.177.017h-.353l-.177-.017h-.16l-.162-.031-.177-.015-.16-.033-.16-.032-.162-.031-.145-.048-.16-.047-.16-.048-.147-.063-.143-.048-.145-.064-.145-.063-.145-.063-.128-.08-.145-.063-.128-.08-.145-.095-.13-.08-.143-.094-.13-.096-.143-.096-.13-.095-.096.128-.113.111-.096.127-.113.126-.096.111-.096.128-.113.127-.096.111-.113.126-.096.113-.113.126-.096.127-.096.111-.113.128-.096.126-.113.11-.096.128.128.111.113.096.128.095.128.096.13.094.128.096.128.08.128.08.147.079.128.078.143.08.147.064.143.078.145.063.145.064.16.063.145.048.16.048.145.063.162.048.16.047.145.033.16.046.162.033.16.032.322.063.16.016.162.032.175.015.162.016.16.017h.177l.16.015h.676l.16-.015.178-.017.161-.016.145-.015.16-.017.162-.031.144-.032.145-.031.16-.032.146-.048.16-.048.16-.048.16-.063.163-.063.144-.08.144-.064.146-.08.129-.094.128-.078.128-.096.113-.094.128-.113.096-.094.113-.111.096-.111.08-.128.097-.127.162-.254.064-.142.064-.128.064-.142.049-.16.032-.142.047-.159.034-.159.015-.174.017-.159zm-11.277 3.174h.162v-2.619h-6.303v-1.967h5.595v-2.46h-5.595v-1.89h6.222v-2.62h-9.293v11.556h9.212zm-11.746 0h.16V64.222h-3.295l-.081.127-.08.143-.097.126-.081.144-.08.126-.08.144-.096.126-.081.142-.081.128-.08.126-.096.142-.08.128-.081.142-.081.128-.095.14-.08.128-.082.128-.08.14-.08.128-.096.143-.08.127-.082.141-.08.128-.097.142-.079.126-.08.128-.082.142-.096.128-.08.142-.08.126-.08.144-.097.126-.08.142-.082.128-.079-.128-.08-.142-.099-.126-.079-.144-.08-.126-.08-.142-.08-.128-.099-.142-.079-.128-.08-.126-.08-.142-.08-.128-.099-.14-.079-.128-.08-.143-.08-.127-.081-.141-.098-.128-.079-.127-.08-.141-.082-.128-.096-.142-.08-.128-.08-.142-.08-.126-.082-.128-.096-.142-.08-.126-.08-.144-.08-.126-.082-.144-.096-.126-.08-.143-.08-.127h-3.296v11.556h3.055v-6.802l.096.128.08.144.097.126.08.144.097.127.08.143.097.127.08.143.097.127.08.143.097.127.08.144.095.128.081.142.096.128.081.142.098.128.096.142.08.128.095.144.081.127.098.143.08.127.097.142.08.128.095.142.081.128.096.142.081.13.096.142.081.127.096.143.081.127.096.143h.064l.081-.126.096-.144.081-.128.096-.127.081-.143.096-.127.08-.128.08-.142.098-.128.08-.126.097-.129.08-.142.096-.127.08-.126.081-.144.096-.128.081-.127.096-.143.08-.127.097-.128.081-.142.08-.128.097-.126.08-.144.096-.127.08-.128.097-.126.08-.144.08-.127.098-.128.08-.142.096-.128.081-.126.096-.144.08-.127v6.833h2.943zm-18.655-4.762l.064.143h-2.717l.064-.143.049-.144.064-.159.065-.142.048-.144.064-.143.064-.159.064-.144.049-.142.064-.143.064-.144.049-.159.064-.142.064-.144.049-.143.064-.144.064-.159.064-.142.049-.144.064-.144.064-.158.049-.143.064-.144.064.144.049.143.062.158.066.144.049.144.064.142.064.16.047.143.066.143.064.144.047.142.066.16.047.143.064.143.064.142.05.144.063.16.064.142.05.144.063.142.064.16.05.143zm5.049 4.762h.16l-.064-.142-.064-.143-.064-.144-.05-.159-.063-.14-.064-.143-.064-.144-.13-.285-.063-.16-.065-.142-.05-.144-.062-.142-.065-.143-.064-.142-.064-.16-.065-.143-.13-.285-.046-.143-.065-.144-.065-.159-.064-.142-.064-.143-.128-.285-.065-.143-.048-.16-.064-.142-.065-.142-.064-.143-.065-.144-.064-.142-.064-.16-.064-.142-.05-.142-.062-.144-.065-.143-.065-.142-.064-.16-.064-.142-.13-.286-.047-.143-.064-.142-.065-.143-.063-.159-.13-.285-.064-.144-.064-.142-.049-.143-.064-.159-.064-.142-.064-.144-.065-.142-.065-.143-.064-.142-.064-.16-.048-.142-.063-.144-.066-.142-.064-.143-.064-.144-.064-.157-.065-.144-.065-.143-.047-.142-.064-.143-.066-.144-.062-.159-.066-.142-.064-.143-.064-.142-.064-.144-.049-.143-.064-.159-.064-.142-.064-.143-.066-.144h-2.973l-.064.144-.064.143-.066.142-.047.16-.064.142-.064.144-.066.142-.063.143-.065.142-.064.16-.066.143-.047.143-.128.285-.064.144-.064.157-.066.144-.064.143-.064.142-.05.144-.063.143-.064.159-.128.285-.064.142-.065.144-.065.142-.047.16-.065.142-.064.142-.065.144-.064.143-.064.142-.064.16-.065.142-.048.142-.129.285-.064.144-.065.143-.064.159-.064.142-.064.143-.05.144-.063.142-.064.143-.065.159-.064.142-.064.144-.064.143-.065.142-.048.143-.064.159-.065.143-.064.143-.064.142-.065.143-.064.142-.064.16-.049.143-.128.285-.064.143-.065.144-.064.159-.063.142-.066.143-.048.142-.065.144-.064.143-.064.159-.064.142-.064.143-.13.286-.048.141-.063.16-.13.286-.064.142h3.249l.064-.142.048-.143.065-.144.064-.159.048-.14.065-.143.064-.144.047-.143.065-.142.065-.143.047-.144.064-.159.066-.142.048-.143.063-.142h4.615l.064.142.05.143.063.142.064.16.048.143.065.143.064.142.048.143.13.286.046.141.065.16.065.143.049.143.063.142h3.152zM23.27 74.302l.113-.094v-5.16h-5.306v2.318h2.348v1.444l-.128.08-.115.064-.143.063-.13.063-.145.064-.143.032-.16.048-.162.031-.16.032-.162.015-.177.016-.177.017h-.37l-.176-.017-.16-.016-.162-.032-.16-.031-.162-.048-.16-.047-.145-.064-.145-.063-.143-.063-.13-.08-.128-.08-.128-.095-.13-.095-.112-.096-.097-.11-.112-.112-.097-.11-.096-.128-.08-.126-.082-.127-.08-.143-.063-.144-.066-.159-.047-.126-.048-.142-.032-.144-.065-.285-.017-.16-.015-.143-.016-.158v-.366l.016-.159.015-.157.033-.176.033-.142.032-.158.048-.159.063-.142.049-.144.065-.143.081-.127.08-.143.08-.127.08-.111.097-.126.112-.112.097-.111.112-.095.113-.096.113-.094.128-.08.128-.08.13-.079.145-.063.143-.064.145-.047.145-.048.145-.031.16-.032.145-.016.162-.017h.337l.177.017.177.016.16.015.16.032.162.033.145.031.143.047.145.048.13.048.128.063.13.064.143.08.128.078.13.08.128.079.128.096.13.079.128.111.128.095.096-.126.113-.111.096-.128.113-.127.096-.126.098-.113.112-.126.097-.127.112-.128.097-.11.096-.127.113-.127.096-.111.096-.128.113-.127.096-.126.113-.111.096-.128-.128-.096-.13-.11-.128-.095-.128-.096-.128-.08-.128-.094-.146-.08-.129-.08-.143-.079-.13-.08-.145-.062-.143-.08-.147-.063-.143-.064-.145-.063-.145-.048-.128-.048-.145-.032-.145-.046-.145-.033-.143-.032-.147-.031-.16-.032-.16-.031-.145-.017-.177-.031-.16-.017h-.162l-.177-.015-.177-.016h-.691l-.16.016-.162.015-.32.033-.162.032-.16.015-.16.031-.145.048-.162.032-.145.048-.144.031-.144.065-.162.046-.128.048-.16.08-.145.063-.145.064-.145.08-.145.08-.145.079-.127.08-.13.077-.128.096-.13.08-.128.094-.112.096-.129.111-.113.095-.112.112-.112.111-.097.111-.112.111-.097.111-.097.128-.096.126-.096.127-.162.254-.079.127-.08.128-.082.142-.064.143-.128.286-.064.143-.066.159-.047.142-.049.159-.047.142-.032.16-.049.158-.032.143-.017.159-.032.157-.016.176-.016.159v.157l-.015.176v.523l.015.16.016.158.016.16.017.142.032.159.015.142.032.16.05.142.031.159.05.142.031.144.064.142.049.128.064.142.064.143.064.142.064.144.081.126.081.144.08.126.08.128.096.127.081.126.096.111.097.128.097.11.112.112.112.11.113.097.113.11.112.097.113.094.13.096.127.095.129.096.128.078.13.08.144.079.128.08.145.079.145.063.144.063.146.064.16.063.144.048.145.063.145.048.161.032.144.048.162.031.145.032.16.031.16.032.162.016.16.017.16.015.177.016.16.015h.693l.177-.015.16-.016.177-.015.162-.017.175-.016.162-.015.16-.032.162-.033.143-.031.162-.032.145-.048.16-.046.145-.048.145-.048.145-.048.143-.063.162-.063.145-.065.16-.063.145-.08.145-.062.144-.08.145-.08.144-.077.129-.08.13-.08.127-.095.129-.08.13-.094.11-.08.13-.096zM28 36.016v-5.994h-7.978V19.99H28V14H14v40h14v-5.982h-7.978V36.016H28zm40.003 10.5c0 1.573-.79 2.303-2.341 2.303h-1.15c-1.61 0-2.494-.73-2.494-2.303V22.005c0-1.574.883-2.624 2.493-2.624h1.035c1.888 0 2.457.638 2.457 2.624v7.993l5.997.01v-8.614c0-4.886-2.542-7.358-7.544-7.358h-2.992c-5.002 0-7.464 3.08-7.464 7.969v24.792c0 4.888 2.462 7.227 7.464 7.227h3.049c5.004 0 7.487-2.34 7.487-7.227v-8.791h-5.997v8.51zM48 54h6V14h-6v40zm-8.005-22.228c0 1.6-.437 2.228-1.888 2.228h-2.113V19.372h2.113c1.45 0 1.888.742 1.888 2.342v10.058zM30 14v40h5.994V39.485h3.026c4.672 0 6.98-2.456 6.98-7.426v-10.63C46 16.456 43.692 14 39.02 14H30zm30 76.038H28l16 5.966 16-5.966z"
            />
        )
    },
    EPIC_SMALL: {
        viewBox: '0 0 80 80',
        data: (
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h80v80H0z" />
                <path
                    className="background"
                    d="M21.127 12C18.113 12 17 13.152 17 16.274v37.67c0 .354.013.682.044.986.069.682-.044 2.028 2.324 3.103 1.579.717 7.75 3.365 18.514 7.943 1.042.448 1.335.554 2.116.554.697.014 1.157-.103 2.107-.554 10.772-4.435 16.946-7.082 18.525-7.943 2.367-1.29 2.367-3.735 2.367-4.089v-37.67c0-3.122-1.113-4.274-4.127-4.274H21.127z"
                    fill="#fff"
                />
                <path
                    className="foreground"
                    d="M55.674 50.397l-.009.084-.008.092-.017.084-.025.084-.017.075-.025.084-.034.076-.033.067-.034.075-.084.134-.05.068-.043.067-.05.059-.06.059-.05.05-.066.06-.06.05-.066.05-.067.041-.067.05-.077.042-.075.034-.076.042-.084.034-.084.033-.084.025-.084.026-.076.025-.084.017-.076.016-.075.017-.084.017-.084.008-.076.008-.084.009-.093.009-.083.008h-.354l-.083-.008H52.9l-.084-.009-.084-.009-.092-.008-.084-.016-.084-.009-.169-.033-.083-.017-.085-.017-.084-.025-.075-.018-.084-.024-.085-.025-.075-.034-.084-.025-.076-.026-.084-.033-.075-.034-.076-.033-.075-.042-.077-.034-.075-.042-.067-.04-.076-.043-.067-.042-.067-.042-.067-.05-.068-.05-.067-.052-.067-.05-.059-.05-.067-.059.05-.067.06-.06.05-.066.059-.067.05-.059.05-.067.06-.067.05-.06.058-.066.05-.059.06-.067.05-.067.05-.06.06-.066.05-.067.058-.059.05-.067.068.05.075.05.068.051.075.05.068.042.076.05.067.043.075.033.067.042.076.034.076.033.076.034.075.025.076.034.084.025.084.025.076.025.084.017.084.016.084.018.092.008.085.016h.083l.093.01h.184l.093-.01.084-.016.076-.017.075-.017.068-.025.059-.033.067-.051.05-.059.033-.067.026-.075.009-.085v-.016l-.01-.1-.033-.085-.042-.059-.059-.05-.067-.05-.067-.034-.076-.033-.084-.034-.1-.042-.06-.017-.067-.017-.075-.025-.076-.017-.084-.025-.084-.017-.092-.025-.085-.017-.092-.025-.084-.017-.084-.025-.084-.017-.084-.024-.076-.026-.084-.016-.075-.026-.076-.025-.076-.025-.092-.034-.084-.033-.085-.034-.083-.034-.076-.042-.084-.042-.068-.042-.075-.042-.067-.05-.067-.042-.06-.05-.058-.06-.059-.058-.05-.059-.05-.058-.043-.059-.042-.067-.042-.076-.033-.058-.026-.067-.025-.076-.025-.067-.017-.084-.017-.075-.008-.084-.008-.084-.01-.092v-.194l.01-.084.008-.075.008-.084.034-.151.025-.076.017-.076.034-.075.033-.075.034-.076.042-.076.042-.075.05-.068.05-.067.06-.067.059-.058.058-.068.068-.058.058-.042.068-.051.067-.05.067-.042.075-.042.076-.034.076-.042.076-.034.083-.024.084-.034.077-.025.067-.017.075-.017.076-.017.084-.016.076-.017.084-.009.084-.008.168-.017h.36l.093.009.093.008h.084l.093.008.084.017.092.009.084.016.076.017.083.017.085.017.075.017.084.024.076.026.075.016.085.034.075.026.076.033.075.033.085.034.076.042.067.034.075.042.076.042.067.042.076.05.067.042.068.05.067.05.067.05-.05.068-.043.068-.05.067-.051.067-.05.076-.042.066-.051.068-.05.067-.042.067-.05.067-.051.068-.042.066-.05.076-.05.067-.051.067-.042.068-.05.066-.068-.05-.075-.042-.067-.042-.068-.05-.076-.034-.067-.042-.076-.033-.067-.034-.075-.033-.067-.034-.076-.025-.068-.033-.092-.026-.084-.025-.084-.026-.084-.016-.084-.017-.084-.017-.084-.008-.084-.008-.076-.009H52.9l-.092.017-.084.017-.076.017-.067.033-.059.033-.076.068-.05.075-.033.076-.01.084v.017l.01.109.041.093.034.05.058.058.077.042.067.042.084.034.092.034.102.033.067.017.067.025.075.017.076.025.084.017.092.025.093.026.092.024.093.018.084.024.092.026.085.016.083.026.084.025.076.025.084.025.075.025.076.026.093.032.083.042.085.034.084.042.076.042.075.043.067.04.067.052.068.042.067.058.067.059.059.067.06.06.05.066.05.076.042.066.042.077.034.066.025.076.025.076.017.075.033.168.009.084.008.092v.202l-.008.093zm-5.895 1.678h-4.815v-6.111h4.858v1.385h-3.253v1h2.925v1.3h-2.925v1.041h3.295v1.385h-.085zm-6.14 0h-1.538V48.46l-.042.068-.05.076-.042.066-.05.068-.043.075-.05.068-.042.067-.043.076-.05.067-.042.067-.05.068-.042.076-.05.066-.042.068-.043.075-.05.068-.042.067-.05.075-.043.068-.05.067-.042.076L41.1 50l-.05.067-.042.076-.051.068-.042.067-.05.067-.043.075-.041.068-.05.067-.043.076-.05.067-.042.067-.05.077-.043.066h-.033l-.05-.075-.043-.068-.05-.075-.042-.067-.05-.076-.043-.068-.05-.075-.042-.068-.05-.075-.042-.067-.051-.076-.042-.067-.05-.076-.043-.067-.05-.076-.042-.068-.05-.075-.051-.067-.042-.076-.05-.067-.043-.075-.05-.068-.041-.076-.05-.067-.043-.076-.051-.067-.042-.076-.05-.067-.042-.075-.05-.068-.043-.076-.05-.067-.042-.076-.05-.067v3.597h-1.597v-6.111h1.723l.041.067.042.075.05.067.043.076.042.067.042.076.042.066.05.076.042.067.043.067.041.075.042.068.05.075.043.067.042.075.042.067.05.068.043.074.042.068.042.075.041.068.051.074.043.068.041.075.042.067.042.067.05.075.043.068.042.075.042.067.041.076.051.066.043.076.041.067.042-.067.043-.076.05-.066.042-.076.042-.067.042-.075.05-.068.042-.075.043-.067.041-.067.05-.075.043-.068.042-.074.042-.068.05-.075.042-.068.042-.074.042-.068.043-.067.05-.075.041-.067.043-.075.042-.068.05-.075.042-.067.042-.067.042-.076.05-.066.043-.076.041-.067.042-.076.052-.067.041-.075.042-.067h1.723v6.11h-.084zm-9.751-2.518l-.026-.077-.033-.084-.034-.075-.025-.076-.034-.075-.033-.085-.026-.076-.033-.075-.034-.075-.024-.077-.035-.084-.024-.075-.034-.076-.034-.075-.025-.077-.033-.084-.034-.075-.025-.076-.035-.076-.032-.084-.026-.076-.034-.076-.033.076-.026.076-.033.084-.034.076-.025.076-.034.075-.033.084-.034.077-.025.075-.034.076-.033.075-.026.084-.033.077-.034.075-.025.075-.034.076-.033.085-.034.075-.024.076-.035.075-.033.084-.026.077-.033.075h1.42l-.033-.075zm2.639 2.518h-1.648L34.846 52l-.025-.076-.034-.076-.034-.084-.025-.075-.067-.151-.025-.075-.034-.076-.034-.075-.025-.076-.033-.084-.034-.076-.025-.075-.034-.075h-2.412l-.033.075-.025.075-.035.076-.033.084-.025.076-.033.075-.035.076-.024.075-.034.076-.033.075-.026.075-.033.084-.034.076-.025.076-.034.075h-1.698L29.88 52l.067-.152.033-.084.026-.075.067-.151.034-.075.033-.076.034-.084.033-.075.034-.076.025-.076.035-.075.032-.075.034-.084.034-.077.034-.075.067-.15.025-.077.034-.084.033-.075.034-.076.033-.075.034-.075.034-.076.034-.085.024-.075.035-.075.033-.076.034-.076.033-.075.034-.084.033-.075.033-.076.026-.076.034-.075.033-.076.034-.084.034-.075.033-.076.067-.151.026-.075.033-.076.034-.084.033-.075.034-.075.034-.077.034-.075.033-.075.025-.084.034-.076.034-.076.033-.075.067-.15.034-.085.033-.075.026-.076.033-.076.034-.075.034-.076.033-.084.034-.076.067-.15.025-.076.034-.076.033-.084.035-.075.032-.076.035-.075.033-.076.034-.076.024-.084.035-.075.033-.075.034-.076h1.554l.034.076.034.075.033.075.034.084.025.076.034.076.033.075.034.076.034.075.033.084.034.076.034.076.024.075.034.075.034.076.034.084.033.076.034.075.034.076.033.076.025.075.034.084.033.075.034.076.034.075.033.076.034.076.033.084.026.075.033.075.034.077.068.15.032.084.035.076.033.075.025.075.068.152.033.075.034.084.033.076.034.075.033.076.026.076.033.075.034.084.033.075.034.076.034.076.033.075.034.075.025.085.034.076.067.15.033.076.034.075.034.084.034.076.024.076.068.15.034.077.033.084.034.075.034.075.033.076.025.076.035.075.032.084.068.15.034.077.033.075.034.075.025.084.034.076.033.076.034.075h-.084zm-7.363-.78l-.068.05-.058.042-.068.05-.067.042-.067.051-.068.042-.067.042-.075.041-.076.042-.075.042-.076.034-.076.042-.083.033-.076.034-.085.033-.075.034-.075.025-.076.026-.076.025-.084.025-.075.025-.085.017-.075.016-.084.018-.084.016-.085.008-.091.009-.085.009-.092.008-.084.008-.093.008h-.362l-.084-.008-.092-.008-.084-.008-.083-.009-.085-.009-.084-.016-.084-.017-.075-.017-.085-.016-.075-.026-.084-.016-.076-.026-.076-.033-.075-.025-.084-.034-.076-.034-.075-.033-.076-.034-.076-.042-.067-.042-.075-.042-.068-.042-.067-.04-.067-.052-.067-.05-.068-.05-.059-.05-.058-.051-.06-.059-.058-.05-.06-.06-.057-.058-.051-.059-.05-.067-.051-.059-.042-.066-.05-.068-.043-.067-.041-.067-.042-.076-.043-.067-.033-.076-.034-.075-.033-.076-.034-.075-.025-.067-.034-.076-.017-.076-.025-.075-.017-.084-.025-.076-.017-.084-.008-.075-.017-.084-.009-.075-.008-.084-.008-.085-.008-.084v-.276l.008-.093v-.084l.008-.084.008-.092.017-.084.009-.084.017-.075.025-.084.017-.084.025-.076.025-.084.025-.075.034-.084.034-.075.067-.152.033-.075.043-.076.042-.067.041-.068.085-.134.05-.067.05-.067.05-.067.052-.059.058-.058.05-.06.059-.058.06-.06.058-.05.067-.058.06-.05.066-.05.068-.043.067-.05.068-.042.066-.042.076-.042.075-.042.076-.042.076-.034.076-.033.083-.042.067-.026.085-.024.076-.034.075-.017.075-.025.085-.017.076-.025.083-.017.084-.008.085-.017.167-.017.085-.008.084-.009h.36l.093.009.093.008h.084l.084.009.093.016.075.009.084.017.084.016.076.017.075.017.076.017.076.025.076.016.067.026.075.025.076.033.075.034.077.034.075.042.075.033.068.042.075.042.067.042.077.042.067.05.067.042.067.051.067.05.068.059.067.05-.05.068-.06.059-.05.066-.059.068-.05.067-.05.059-.06.067-.05.067-.05.058-.059.068-.051.067-.058.067-.051.06-.05.066-.06.067-.05.068-.059.059-.05.066-.067-.05-.067-.058-.068-.043-.067-.05-.067-.042-.068-.042-.067-.042-.075-.042-.067-.034-.067-.033-.068-.025-.076-.026-.075-.024-.076-.017-.084-.018-.084-.016-.084-.008-.092-.009-.093-.009h-.176l-.084.01-.076.008-.084.017-.076.016-.076.026-.075.024-.075.034-.076.034-.068.042-.067.042-.067.042-.059.05-.059.05-.058.05-.051.06-.058.059-.051.066-.042.059-.042.067-.042.076-.042.067-.034.075-.026.077-.032.075-.026.084-.017.083-.016.076-.018.092-.008.084-.008.084v.193l.008.084.008.076.009.084.034.15.017.077.025.075.024.067.035.084.033.076.042.075.043.068.041.066.05.068.051.058.059.06.05.058.059.05.068.05.067.051.067.042.067.042.075.034.076.033.076.034.084.025.084.025.084.017.085.016.083.01.093.008h.193l.092-.009.093-.009.084-.008.084-.016.085-.017.083-.025.075-.017.076-.034.068-.033.075-.034.06-.034.067-.042v-.764h-1.228v-1.225h2.774v2.728l-.059.05zM31.636 31.047v-3.17h-4.17v-5.305h4.17v-3.168h-7.318v21.154h7.318v-3.164h-4.17v-6.347zM52.547 36.6c0 .832-.413 1.218-1.224 1.218h-.601c-.842 0-1.303-.386-1.303-1.218V23.637c0-.832.461-1.387 1.303-1.387h.54c.987 0 1.285.337 1.285 1.387v4.227l3.135.006v-4.556c0-2.584-1.33-3.891-3.944-3.891h-1.564c-2.615 0-3.901 1.63-3.901 4.214v13.111c0 2.585 1.286 3.823 3.901 3.823h1.594c2.616 0 3.914-1.238 3.914-3.823V32.1h-3.135v4.5zM42.09 40.558h3.137V19.404h-3.136zM37.906 28.802c0 .846-.228 1.179-.986 1.179h-1.105v-7.736h1.105c.758 0 .986.392.986 1.238v5.32zm-5.224-9.398v21.154h3.133v-7.676h1.582c2.442 0 3.648-1.3 3.648-3.928v-5.622c0-2.629-1.206-3.928-3.648-3.928h-4.715zM48.364 59.616L40 62.771l-8.364-3.155z"
                    fill="#333"
                />
            </g>
        )
    },
    EXTERNAL_LINK: {
        viewBox: '0 0 13 13',
        data: (
            <path
                d="M10,10 L3,10 L3,3 L6.5,3 L6.5,2 L3,2 C2.445,2 2,2.45 2,3 L2,10 C2,10.55 2.445,11 3,11 L10,11 C10.55,11 11,10.55 11,10 L11,6.5 L10,6.5 L10,10 Z M7.5,0 L7.5,3 L9.295,3 L4.38,7.915 L5.085,8.62 L10,3.705 L10,5.5 L11,5.5 L11,2 L7.5,2 Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        )
    },
    EXTERNAL_LINK_V2: {
        viewBox: '0 0 8 7',
        data: (
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="03_Content-8" transform="translate(-822.000000, -269.000000)">
                    <g id="04-About-Game" transform="translate(574.000000, 232.000000)">
                        <g id="Read-More">
                            <g id="Group-21" transform="translate(249.000000, 37.000000)">
                                <path
                                    d="M0,6.98645433 L4.97064209,1.97119554"
                                    id="Path-11"
                                    stroke="currentColor"
                                />
                                <polygon
                                    id="Path-12"
                                    fill="currentColor"
                                    points="2.47241211 0.518434686 6.47241211 4.51843469 6.47241211 0.518434686"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        )
    },
    FACEBOOK: {
        viewBox: '0 0 13 24',
        data: (
            <path
                d="M8.28 23.85V13.09h3.6l.55-4.2H8.28V6.23c0-1.21.33-2.04 2.07-2.04h2.22V.43C12.2.38 10.87.27 9.34.27c-3.2 0-5.4 1.95-5.4 5.54V8.9H.34v4.19h3.62v10.76h4.33z"
                fill="currentColor"
                fillRule="nonzero"
            />
        )
    },
    FRIENDS: {
        viewBox: '0 0 17 11',
        data: (
            <path
                d="M12.5 5C13.875 5 15 3.875 15 2.5S13.875 0 12.5 0A2.507 2.507 0 0 0 10 2.5C10 3.875 11.125 5 12.5 5zm-7 0C6.875 5 8 3.875 8 2.5S6.875 0 5.5 0A2.508 2.508 0 0 0 3 2.5C3 3.875 4.125 5 5.5 5zm-.056 1C3.616 6 0 6.927 0 8.823V11h11V8.823C11 6.927 7.272 6 5.444 6zm6.21 1c-.228 0-.386 0-.654.035.878.602 1.2.992 1.2 2.053V11H17V9.088C17 7.425 13.45 7 11.655 7z"
                fill="currentColor"
                fillRule="nonzero"
            />
        )
    },
    FULLSCREEN: {
        viewBox: '0 0 14 14',
        data: (
            <g fill="none" fillRule="evenodd">
                <path d="M-5-5h24v24H-5z" />
                <path
                    d="M2 9H0v5h5v-2H2V9zM0 5h2V2h3V0H0v5zm12 7H9v2h5V9h-2v3zM9 0v2h3v3h2V0H9z"
                    fill="currentColor"
                    fillRule="nonzero"
                />
            </g>
        )
    },
    FULLSCREEN_EXIT: {
        viewBox: '0 0 14 14',
        data: (
            <g fill="none" fillRule="evenodd">
                <path d="M-5-5h24v24H-5z" />
                <path
                    d="M0 11h3v3h2V9H0v2zm3-8H0v2h5V0H3v3zm6 11h2v-3h3V9H9v5zm2-11V0H9v5h5V3h-3z"
                    fill="currentColor"
                    fillRule="nonzero"
                />
            </g>
        )
    },
    GIFT: {
        viewBox: '0 0 16 16',
        data: (
            <path
                fill="currentColor"
                d="M12.055 5c0.283-0.201 0.555-0.425 0.804-0.674 0.522-0.522 0.871-1.164 0.983-1.808 0.123-0.706-0.057-1.362-0.494-1.798-0.348-0.348-0.82-0.533-1.365-0.533-0.775 0-1.593 0.372-2.242 1.021-1.039 1.039-1.644 2.472-1.97 3.496-0.241-1.028-0.722-2.416-1.657-3.351-0.501-0.501-1.142-0.759-1.748-0.759-0.495 0-0.965 0.172-1.317 0.523-0.781 0.781-0.675 2.153 0.236 3.064 0.325 0.325 0.705 0.595 1.105 0.819h-3.391v4h1v7h12v-7h1v-4h-2.945zM10.536 2.003c0.433-0.433 0.974-0.692 1.446-0.692 0.167 0 0.402 0.035 0.57 0.203 0.407 0.407 0.178 1.349-0.489 2.016-0.687 0.687-1.61 1.159-2.413 1.47h-0.792c0.29-0.899 0.813-2.132 1.678-2.997zM3.655 2.514c-0.011-0.143-0.001-0.41 0.191-0.601 0.16-0.16 0.372-0.194 0.521-0.194v0c0.332 0 0.679 0.157 0.952 0.429 0.529 0.529 0.965 1.371 1.26 2.436 0.008 0.029 0.016 0.057 0.023 0.086-0.028-0.008-0.057-0.015-0.086-0.023-1.064-0.295-1.906-0.731-2.436-1.26-0.247-0.247-0.403-0.565-0.426-0.872zM7 15h-4v-6.5h4v6.5zM7 8h-5v-2h5v2zM13 15h-4v-6.5h4v6.5zM14 8h-5v-2h5v2z"
            />
        )
    },
    HEADPHONES: {
        viewBox: '0 0 16 16',
        data: (
            <Fragment>
                <path
                    fill="currentColor"
                    d="M4.5 9h-1v7h1c0.275 0 0.5-0.225 0.5-0.5v-6c0-0.275-0.225-0.5-0.5-0.5z"
                />
                <path
                    fill="currentColor"
                    d="M11.5 9c-0.275 0-0.5 0.225-0.5 0.5v6c0 0.275 0.225 0.5 0.5 0.5h1v-7h-1z"
                />
                <path
                    fill="currentColor"
                    d="M16 8c0-4.418-3.582-8-8-8s-8 3.582-8 8c0 0.96 0.169 1.88 0.479 2.732-0.304 0.519-0.479 1.123-0.479 1.768 0 1.763 1.304 3.222 3 3.464v-6.928c-0.499 0.071-0.963 0.248-1.371 0.506-0.084-0.417-0.129-0.849-0.129-1.292 0-3.59 2.91-6.5 6.5-6.5s6.5 2.91 6.5 6.5c0 0.442-0.044 0.874-0.128 1.292-0.408-0.259-0.873-0.435-1.372-0.507v6.929c1.696-0.243 3-1.701 3-3.464 0-0.645-0.175-1.249-0.479-1.768 0.31-0.853 0.479-1.773 0.479-2.732z"
                />
            </Fragment>
        )
    },
    HOME: {
        viewBox: '0 0 18 19',
        data: (
            <g fill="none" fillRule="evenodd">
                <path d="M-13-13h44v44h-44z" />
                <path
                    fill="currentColor"
                    d="M12 18.014V12a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v6.014H1c-.503.008-1-.49-1-1v-12c0-.643.45-1.066 1-1.326L8.042.208c.55-.259 1.372-.296 2 0l6.964 3.48c.55.26 1.007.608.994 1.326v12c.006.51-.491 1.008-1 1h-5z"
                />
            </g>
        )
    },
    LAUNCH: {
        viewBox: '0 0 24 24',
        data: (
            <g fill="none">
                <path d="M0 0h24v24H0z" />
                <path
                    fill="currentColor"
                    d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
                />
            </g>
        )
    },
    LIBRARY: {
        viewBox: '0 0 16 16',
        data: (
            <path
                d="M1 0h5.2a1 1 0 0 1 1 1v5.2a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm8.8 0H15a1 1 0 0 1 1 1v5.2a1 1 0 0 1-1 1H9.8a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zM1 8.8h5.2a1 1 0 0 1 1 1V15a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V9.8a1 1 0 0 1 1-1zm8.8 0H15a1 1 0 0 1 1 1V15a1 1 0 0 1-1 1H9.8a1 1 0 0 1-1-1V9.8a1 1 0 0 1 1-1z"
                fill="currentColor"
                fillRule="nonzero"
            />
        )
    },
    LINK: {
        viewBox: '0 0 21 12',
        data: (
            <g fill="currentColor" fillRule="evenodd">
                <path d="M5.965 8.891a2.939 2.939 0 0 1-2.948-2.948 2.94 2.94 0 0 1 2.948-2.948l3.122.014A1.91 1.91 0 0 1 10.99 4.91c0 .67.549 1.22 1.219 1.22s1.22-.55 1.22-1.22A4.357 4.357 0 0 0 9.086.57L5.965.557A5.388 5.388 0 0 0 .578 5.944 5.38 5.38 0 0 0 2.16 9.749a5.412 5.412 0 0 0 3.805 1.58c.67 0 1.22-.549 1.22-1.219s-.55-1.219-1.22-1.219z" />
                <path d="M20.249 5.942A5.386 5.386 0 0 0 14.862.556c-.67 0-1.219.55-1.22 1.22 0 .67.55 1.219 1.22 1.219a2.939 2.939 0 0 1 2.948 2.947 2.94 2.94 0 0 1-2.948 2.949l-3.122-.014a1.876 1.876 0 0 1-1.903-1.902c0-.67-.55-1.22-1.22-1.22-.67 0-1.219.55-1.219 1.22 0 1.206.483 2.278 1.273 3.068a4.301 4.301 0 0 0 3.069 1.273h3.108a5.37 5.37 0 0 0 5.4-5.374z" />
            </g>
        )
    },
    MENU: {
        viewBox: '0 0 18 11',
        data: (
            <path
                d="M0 11h18v-1H0zm0-5h18V5H0zm0-6v1h18V0z"
                fill="currentColor"
                fillRule="evenodd"
            />
        )
    },
    OFFLINE: {
        viewBox: '0 0 12 11',
        data: (
            <path
                d="M11.82 3.5c-.225-.17-2.465-2-5.82-2-.75 0-1.445.095-2.075.24L9.09 6.9l2.73-3.4zm-3.3 4.11L1.635.72 1 1.36l1.025 1.03C.955 2.88.295 3.41.18 3.5l5.815 7.245.005.005.005-.005 1.95-2.43 1.66 1.66.635-.635-1.73-1.73z"
                fill="currentColor"
                fillRule="nonzero"
            />
        )
    },
    STRESSED_FACE: {
        viewBox: '0 0 45 52',
        data: (
            <g fill="none" fillRule="evenodd">
                <path
                    d="M4.058 0C1.094 0 0 1.098 0 4.075v35.922c0 .338.013.65.043.94.068.65-.043 1.934 2.285 2.96 1.553.683 7.62 3.208 18.203 7.573 1.024.428 1.313.529 2.081.529.685.013 1.137-.099 2.072-.53 10.59-4.227 16.66-6.752 18.213-7.573 2.327-1.23 2.097-3.561 2.097-3.899V4.075C44.994 1.098 44.13 0 41.166 0H4.058z"
                    fill="#0078F2"
                />
                <path
                    stroke="#FFF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M14 18l4.91 2.545-2.455 4M25.544 28.705c-1.056-.131-1.806-.14-2.25-.025-.444.115-1.209.514-2.294 1.197M29.09 21.727L25 19.5l2.045-3.5"
                />
            </g>
        )
    },
    PAUSE: {
        viewBox: '0 0 10 14',
        data: <path d="M0 14h3V0H0v14zM7 0v14h3V0H7z" fill="currentColor" fillRule="nonzero" />
    },
    PLAY: {
        viewBox: '0 0 11 14',
        data: <path d="M0 0v14l11-7z" fill="currentColor" fillRule="nonzero" />
    },
    PLAY_EXTERNAL: {
        viewBox: '0 0 82 82',
        data: (
            <path
                d="M41 0C18.357 0 0 18.357 0 41s18.357 41 41 41 41-18.357 41-41S63.643 0 41 0zM29 22l35 20-35 20V22z"
                fill="currentColor"
                fillRule="evenodd"
            />
        )
    },
    PLAYSTATION: {
        viewBox: '0 0 27 21',
        data: (
            <path
                d="M26.52 15.98a4.97 4.97 0 0 1-1.79 1.12l-9.44 3.4v-2.51l6.95-2.48c.79-.28.9-.68.27-.89a4.69 4.69 0 0 0-2.6.13L15.3 16.4v-2.6l.26-.1s1.34-.47 3.22-.67c1.89-.21 4.19.02 6 .71 2.04.64 2.27 1.6 1.75 2.25zm-10.34-4.26v-6.4c0-.75-.13-1.44-.84-1.64-.54-.17-.87.33-.87 1.08v16.02l-4.32-1.37V.31c1.83.34 4.5 1.14 5.95 1.63C19.76 3.2 21 4.76 21 8.28c0 3.44-2.12 4.74-4.82 3.44zm-13.96 6c-2.1-.58-2.45-1.81-1.5-2.52.89-.65 2.39-1.14 2.39-1.14l6.2-2.2v2.5l-4.46 1.6c-.8.28-.91.68-.27.9.64.2 1.8.14 2.59-.14l2.14-.77v2.24l-.43.07c-2.14.35-4.42.2-6.66-.53z"
                fill="currentColor"
                fillRule="evenodd"
            />
        )
    },
    REFRESH: {
        viewBox: '0 0 16 20',
        data: (
            <path
                d="M8 4V0L3 5l5 5V6c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H0c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
                fill="currentColor"
                fillRule="nonzero"
            />
        )
    },
    SEARCH: {
        viewBox: '0 0 21 20',
        data: (
            <g
                transform="scale(1 -1) rotate(-45 -11.93502884 -2)"
                stroke="currentColor"
                strokeWidth="1.65"
                fill="none"
                fillRule="evenodd">
                <circle cx="7.70710678" cy="7.70710678" r="7" />
                <path d="M15.2071068 8.62132034h5.6923881" strokeLinecap="square" />
            </g>
        )
    },
    SETTINGS: {
        viewBox: '0 0 10 10',
        data: (
            <path
                d="M3.587 6.413C3.977 6.804 4.449 7 5 7s1.022-.196 1.413-.587C6.804 6.023 7 5.551 7 5s-.196-1.022-.587-1.413A1.926 1.926 0 0 0 5 3c-.551 0-1.022.196-1.413.587A1.926 1.926 0 0 0 3 5c0 .551.196 1.022.587 1.413zm5.234-.92l1.08.822c.113.078.129.187.049.328L8.917 8.38c-.064.11-.169.141-.313.094l-1.273-.493c-.337.235-.625.4-.865.493L6.274 9.79c-.033.14-.113.211-.24.211H3.966c-.128 0-.208-.07-.24-.211l-.193-1.315a3.956 3.956 0 0 1-.865-.493l-1.273.493c-.144.047-.249.016-.313-.094L.05 6.643c-.08-.14-.064-.25.048-.328l1.081-.822A3.706 3.706 0 0 1 1.155 5c0-.22.008-.383.024-.493L.1 3.685c-.113-.078-.129-.187-.049-.328L1.083 1.62c.064-.11.169-.141.313-.094l1.273.493c.337-.235.625-.4.865-.493L3.726.21C3.76.071 3.84 0 3.966 0h2.067c.128 0 .208.07.24.211l.193 1.315c.304.125.592.29.865.493l1.273-.493c.144-.047.249-.016.313.094L9.95 3.357c.08.14.064.25-.048.328l-1.081.822c.016.11.024.274.024.493 0 .22-.008.383-.024.493z"
                fill="currentColor"
                fillRule="evenodd"
            />
        )
    },
    SOCIAL_DISCORD: {
        viewBox: '0 0 26 19',
        data: (
            <g fill="none" fillRule="evenodd">
                <path d="M-5-9h36v36H-5z" />
                <path
                    d="M9.412 0c-.345.001-3.196.082-6.204 2.317 0 0-3.208 5.77-3.208 12.878 0 0 1.871 3.208 6.795 3.364 0 0 .825-.98 1.493-1.827-2.83-.847-3.899-2.607-3.899-2.607s.223.156.624.38c.022 0 .044.021.089.044.067.044.134.066.2.111.557.312 1.114.557 1.627.758.913.378 2.005.712 3.275.958 1.67.311 3.631.423 5.77.022 1.047-.2 2.117-.49 3.23-.958.78-.29 1.65-.713 2.563-1.315 0 0-1.114 1.805-4.033 2.63.669.824 1.47 1.782 1.47 1.782C24.13 18.38 26 15.172 26 15.195c0-7.107-3.208-12.878-3.208-12.878C19.606-.067 16.554 0 16.554 0l-.312.357c3.787 1.136 5.547 2.807 5.547 2.807a18.52 18.52 0 0 0-6.706-2.117 18.851 18.851 0 0 0-4.5.045c-.134 0-.245.022-.38.044-.779.09-2.673.357-5.056 1.404-.825.356-1.315.624-1.315.624S5.659 1.404 9.669.268L9.446 0h-.034zm-.567 8.221c1.27 0 2.295 1.092 2.272 2.451 0 1.359-1.002 2.45-2.272 2.45-1.248 0-2.273-1.091-2.273-2.45 0-1.359 1.003-2.45 2.273-2.45zm8.132 0c1.247 0 2.272 1.092 2.272 2.451s-1.002 2.45-2.272 2.45c-1.248 0-2.273-1.091-2.273-2.45 0-1.359 1.003-2.45 2.273-2.45z"
                    fill="currentColor"
                    fillRule="nonzero"
                />
                <path d="M-5-9h36v36H-5z" />
            </g>
        )
    },
    SOCIAL_FACEBOOK: {
        viewBox: '0 0 22 22',
        data: (
            <path
                d="M20.786 0H1.214C.544 0 0 .543 0 1.214v19.572C0 21.456.543 22 1.214 22h10.545v-8.508H8.895v-3.33h2.864v-2.45c0-2.842 1.737-4.39 4.27-4.39.855-.001 1.708.042 2.557.13v2.97h-1.745c-1.38 0-1.65.652-1.65 1.616v2.12h3.3l-.428 3.33h-2.89V22h5.613c.67 0 1.214-.543 1.214-1.214V1.214C22 .544 21.457 0 20.786 0z"
                fill="currentColor"
                fillRule="nonzero"
            />
        )
    },
    SOCIAL_GLOBE: {
        viewBox: '0 0 20 20',
        data: (
            <path
                d="M15.818 15.177A7.79 7.79 0 0 0 13 2.81V3c0 1.1-.9 2-2 2H9v2c0 .55-.45 1-1 1H6v2h6c.55 0 1 .45 1 1v3h1c.819 0 1.506.48 1.818 1.177zM2.254 9.187a7.79 7.79 0 0 0 6.318 8.47v-1.071a2.055 2.055 0 0 1-2.041-2.058V13.5L2.254 9.187zm.676 7.883A9.969 9.969 0 0 1 0 10C0 4.48 4.48 0 10 0c.506 0 1 .037 1.482.11C16.302.824 20 4.98 20 10c0 5.523-4.477 10-10 10a9.969 9.969 0 0 1-7.071-2.929z"
                fill="currentColor"
                fillRule="nonzero"
            />
        )
    },
    SOCIAL_INSTAGRAM: {
        viewBox: '0 0 22 22',
        data: (
            <g>
                <defs>
                    <path id="a" d="M0 .007h21.993v21.99H0z" />
                </defs>
                <g fill="none" fillRule="evenodd">
                    <g>
                        <mask id="b" fill="#fff">
                            <use xlinkHref="#a" />
                        </mask>
                        <path
                            d="M10.997.007C8.01.007 7.636.02 6.463.073c-1.17.054-1.97.24-2.67.511a5.39 5.39 0 0 0-1.947 1.269A5.39 5.39 0 0 0 .577 3.8C.305 4.5.12 5.3.067 6.47.012 7.643 0 8.017 0 11.003c0 2.987.013 3.361.066 4.534.054 1.17.24 1.97.511 2.67a5.39 5.39 0 0 0 1.269 1.947 5.39 5.39 0 0 0 1.947 1.269c.7.272 1.5.457 2.67.51 1.173.054 1.547.067 4.534.067 2.986 0 3.36-.013 4.533-.066 1.17-.054 1.97-.24 2.67-.511a5.39 5.39 0 0 0 1.947-1.269 5.39 5.39 0 0 0 1.269-1.947c.272-.7.457-1.5.51-2.67.054-1.173.067-1.547.067-4.534 0-2.986-.013-3.36-.066-4.533-.053-1.17-.24-1.97-.511-2.67a5.39 5.39 0 0 0-1.269-1.947A5.39 5.39 0 0 0 18.2.584c-.7-.272-1.5-.457-2.67-.51C14.357.02 13.983.006 10.997.006zm0 1.981c2.936 0 3.284.012 4.443.064 1.072.05 1.654.228 2.042.379.513.2.88.438 1.264.823.385.384.623.75.823 1.264.15.388.33.97.379 2.042.052 1.16.064 1.507.064 4.443 0 2.937-.012 3.284-.064 4.444-.05 1.072-.228 1.654-.379 2.042-.2.513-.438.88-.823 1.264a3.407 3.407 0 0 1-1.264.823c-.388.15-.97.33-2.042.379-1.16.052-1.507.064-4.443.064-2.937 0-3.285-.012-4.444-.064-1.072-.05-1.654-.229-2.042-.38-.513-.199-.88-.437-1.264-.822a3.407 3.407 0 0 1-.823-1.264c-.15-.388-.33-.97-.379-2.042-.052-1.16-.064-1.507-.064-4.444 0-2.936.012-3.284.064-4.443.05-1.072.229-1.654.38-2.042.199-.513.437-.88.822-1.264A3.407 3.407 0 0 1 4.51 2.43c.388-.15.97-.33 2.042-.379 1.16-.052 1.507-.064 4.444-.064z"
                            fill="currentColor"
                            mask="url(#b)"
                        />
                    </g>
                    <path
                        d="M10.997 14.669a3.665 3.665 0 1 1 0-7.331 3.665 3.665 0 0 1 0 7.331zm0-9.312a5.647 5.647 0 1 0 0 11.293 5.647 5.647 0 0 0 0-11.293zM18.186 5.134a1.32 1.32 0 1 1-2.64 0 1.32 1.32 0 0 1 2.64 0"
                        fill="currentColor"
                    />
                </g>
            </g>
        )
    },
    SOCIAL_NAVER: {
        viewBox: '0 0 23 22',
        data: (
            <g fill="none" fillRule="evenodd">
                <path
                    d="M0 0v22h23V0H0zm13.239 16l-3.547-5.181V16H6V6h3.761l3.55 5.165V6H17v10h-3.761z"
                    fill="currentColor"
                    fillRule="nonzero"
                />
                <path d="M-6-7h36v36H-6z" />
            </g>
        )
    },
    SOCIAL_REDDIT: {
        viewBox: '0 0 26 23',
        data: (
            <g fill="none" fillRule="evenodd">
                <path d="M-5-7h36v36H-5z" />
                <path
                    d="M25.73 9.965c.105 1.115-.418 1.942-1.279 2.58-.207.153-.27.282-.234.548.27 1.994-.311 3.743-1.622 5.246-1.653 1.896-3.8 2.93-6.212 3.475a14.666 14.666 0 0 1-5.078.245c-1.95-.245-3.81-.78-5.487-1.84-1.47-.926-2.679-2.1-3.382-3.726-.494-1.142-.621-2.33-.417-3.555.021-.132-.005-.204-.125-.284-.73-.489-1.259-1.132-1.395-2.022C.152 8.367 2.165 6.99 3.861 7.439c.49.13.944.397 1.41.613.113.052.19.086.314.002 1.36-.928 2.855-1.535 4.463-1.875.897-.19 1.8-.32 2.718-.313.181 0 .217-.097.26-.233.488-1.557.98-3.112 1.471-4.669.174-.552.438-.707 1.003-.586 1.36.29 2.72.576 4.078.874.168.037.264.006.377-.126 1.153-1.341 2.943-.728 3.519.296.72 1.282-.087 2.883-1.573 3.122a2.185 2.185 0 0 1-2.439-1.586c-.06-.228-.168-.303-.383-.347-1.049-.213-2.093-.446-3.138-.67-.083-.018-.168-.027-.273-.044l-1.316 4.097.721.076c2.048.207 3.948.844 5.671 1.98.11.071.174.067.28-.019.93-.76 1.967-.894 3.05-.416 1.001.444 1.554 1.257 1.656 2.35zm-8.728 4.37c.909-.001 1.717-.807 1.713-1.707-.004-.959-.78-1.743-1.723-1.74-.914.003-1.711.785-1.71 1.677 0 .975.774 1.77 1.72 1.77zm.406 3.265c.197-.229.147-.5-.035-.68-.252-.25-.577-.32-.83-.175-.101.059-.194.13-.294.192-1.741 1.058-3.561 1.223-5.446.439-.387-.16-.742-.4-1.106-.611-.27-.158-.61-.102-.87.16-.171.172-.193.468-.022.71.097.137.228.26.365.356 1.179.827 2.504 1.172 4.037 1.19.166-.013.439-.028.711-.053.953-.088 1.862-.339 2.684-.833.3-.182.575-.43.806-.695zm-8.144-3.265c.854-.002 1.673-.84 1.67-1.71-.004-.945-.797-1.737-1.735-1.736-.926 0-1.714.795-1.712 1.727.003.941.808 1.72 1.777 1.719z"
                    fill="currentColor"
                    fillRule="nonzero"
                />
            </g>
        )
    },
    SOCIAL_TWITTER: {
        viewBox: '0 0 24 20',
        data: (
            <path
                d="M7.826 19.143c8.49 0 13.134-7.034 13.134-13.135 0-.2 0-.398-.013-.596a9.392 9.392 0 0 0 2.303-2.39 9.214 9.214 0 0 1-2.651.727 4.632 4.632 0 0 0 2.03-2.554 9.251 9.251 0 0 1-2.932 1.12 4.62 4.62 0 0 0-7.867 4.211 13.106 13.106 0 0 1-9.514-4.823 4.62 4.62 0 0 0 1.43 6.162 4.582 4.582 0 0 1-2.096-.578v.059c0 2.197 1.55 4.09 3.704 4.525a4.609 4.609 0 0 1-2.085.08 4.622 4.622 0 0 0 4.313 3.205A9.263 9.263 0 0 1 .75 17.07a13.069 13.069 0 0 0 7.076 2.07"
                fill="currentColor"
                fillRule="nonzero"
            />
        )
    },
    SOCIAL_TWITCH: {
        viewBox: '0 0 24 20',
        data: (
            <path
                d="M1.406 0L0 3.594V18.28h5v2.657h2.813l2.656-2.657h4.062L20 12.813V0H1.406zm16.719 11.875L15 15h-5l-2.656 2.656V15H3.125V1.875h15v10zM15 5.469v5.468h-1.875V5.47H15zm-5 0v5.468H8.125V5.47H10z"
                fill="currentColor"
                fillRule="nonzero"
            />
        )
    },
    SOCIAL_VK: {
        viewBox: '0 0 22 22',
        data: (
            <g fill="none" fillRule="evenodd">
                <path
                    d="m7.935289,1.584473l5.996485,0c5.472654,0 6.768447,1.26146 6.768447,6.589117l0,5.837609c0,5.327657 -1.295792,6.589117 -6.768447,6.589117l-5.996485,0c-5.472654,0 -6.768447,-1.26146 -6.768447,-6.589117l0,-5.837609c0,-5.327657 1.295792,-6.589117 6.768447,-6.589117m9.222181,6.548858c0.096495,-0.295235 0,-0.509952 -0.427336,-0.509952l-1.419857,0c-0.358411,0 -0.523831,0.187877 -0.620326,0.389174c0,0 -0.730606,1.717733 -1.750698,2.831576c-0.330841,0.322075 -0.482476,0.429433 -0.661681,0.429433c-0.096495,0 -0.22056,-0.107358 -0.22056,-0.402594l0,-2.751057c0,-0.348915 -0.11028,-0.509952 -0.413551,-0.509952l-2.233174,0c-0.22056,0 -0.358411,0.161037 -0.358411,0.322075c0,0.335495 0.510046,0.416014 0.565186,1.355399l0,2.039808c0,0.442853 -0.08271,0.523372 -0.261915,0.523372c-0.482476,0 -1.654203,-1.731153 -2.357239,-3.703862c-0.13785,-0.389174 -0.2757,-0.536792 -0.634111,-0.536792l-1.433642,0c-0.413551,0 -0.482476,0.187877 -0.482476,0.389174c0,0.362334 0.482476,2.187426 2.246959,4.602988c1.171727,1.650634 2.839715,2.53634 4.342282,2.53634c0.909812,0 1.020092,-0.201297 1.020092,-0.536792l0,-1.248041c0,-0.402594 0.08271,-0.469693 0.372196,-0.469693c0.206775,0 0.578971,0.107358 1.419857,0.899126c0.964952,0.939385 1.130372,1.368819 1.667988,1.368819l1.419857,0c0.413551,0 0.606541,-0.201297 0.496261,-0.590471c-0.124065,-0.389174 -0.592756,-0.952805 -1.199297,-1.623795c-0.330841,-0.375754 -0.827101,-0.791768 -0.978737,-0.993064c-0.206775,-0.268396 -0.151635,-0.375754 0,-0.61731c-0.013785,0 1.723128,-2.388723 1.902333,-3.19391"
                    fill="currentColor"
                    fillRule="nonzero"
                />
            </g>
        )
    },
    SOCIAL_WEIBO: {
        viewBox: '0 0 26 22',
        data: (
            <g fill="none" fillRule="evenodd">
                <path d="M-5-7h36v36H-5z" />
                <path
                    d="M18.88 11.007c-.345-.106-.58-.18-.4-.645.39-1.012.43-1.885.007-2.508-.794-1.168-2.964-1.105-5.452-.031 0-.001-.782.352-.582-.287.383-1.268.324-2.33-.27-2.943-1.35-1.392-4.94.053-8.02 3.224C1.858 10.193.52 12.712.52 14.89c0 4.165 5.183 6.951 10.253 6.951 6.647 0 11.07-4.233 11.07-7.393 0-1.91-1.561-2.993-2.963-3.44zm-8.093 8.966c-4.046.405-7.538-1.455-7.801-4.16-.263-2.704 2.805-5.226 6.85-5.633 4.047-.408 7.54 1.454 7.802 4.158.262 2.705-2.804 5.227-6.85 5.635zM25.48 7.615C25.478 3.41 22.11 0 17.954 0a.883.883 0 0 0-.878.889c0 .491.393.889.878.889 3.187 0 5.77 2.615 5.77 5.84 0 .492.393.89.878.89a.883.883 0 0 0 .878-.89v-.003zm-3.489-.13c-.4-1.983-1.945-3.546-3.904-3.953a.878.878 0 0 0-1.036.692c-.098.48.208.95.682 1.05a3.287 3.287 0 0 1 2.539 2.569c.098.48.561.79 1.036.691a.89.89 0 0 0 .683-1.05zm-13.28 5.343c-1.63.332-2.729 1.716-2.456 3.09.273 1.376 1.815 2.221 3.446 1.89 1.63-.332 2.73-1.715 2.456-3.09-.272-1.376-1.816-2.221-3.445-1.89z"
                    fill="currentColor"
                    fillRule="nonzero"
                />
            </g>
        )
    },
    SOCIAL_YOUKU: {
        viewBox: '0 0 30 18',
        data: (
            <g fill="none" fillRule="evenodd">
                <path d="M-3-9h36v36H-3z" />
                <g fill="currentColor" fillRule="nonzero">
                    <path d="M24.328 3.379a22.83 22.83 0 0 1-2.141 2.102c-.366.452-.78.857-1.24 1.217-.534.546-.968 1.189-1.69 1.55V3.932c-.017-2.348-4.49-2.348-4.507 0v12.285c.195.876.601 1.546 1.577 1.658h1.353c.927-.158 1.455-.71 1.577-1.658V13.56c0-.92-.176-2.475.45-1.55.918.883 2.212 1.832 3.382 2.877 1.123 1.005 2.198 2.628 3.38 2.877 2.42.51 3.488-1.772 2.592-3.43-.946-1.752-3.67-2.874-4.846-4.427.792-1.779 5.096-2.872 4.733-5.975-.143-1.225-1.246-1.818-2.361-1.807-.924.01-1.856.433-2.259 1.254zM11.457 0c-.39 0-.78.102-1.115.33-.739.5-1.15 2.042-1.646 3.14C8.15 4.678 7.67 5.895 7.138 6.782 5.698 5.18 4.716 1.63 2.981.329 2.421-.09 1.195-.078.643.33c-1.495 1.103.005 3.053.606 4.075 1.319 2.243 2.78 4.645 3.897 6.707-.726 1.876-4.39 7.176.52 6.877 1.188-.753 1.691-2.32 2.338-3.737 1.32-2.9 2.444-5.405 3.81-8.403.568-1.247 1.937-3.089 1.646-4.5C13.297.56 12.38-.002 11.457 0z" />
                </g>
            </g>
        )
    },
    SOCIAL_YOUTUBE: {
        viewBox: '0 0 25 18',
        data: (
            <g fill="none" fillRule="evenodd">
                <path
                    d="M12.354.139s-7.508 0-9.392.512C1.953.946 1.122 1.816.841 2.888.35 4.86.35 8.945.35 8.945s0 4.101.49 6.043c.282 1.071 1.098 1.926 2.121 2.22 1.9.529 9.392.529 9.392.529s7.522 0 9.406-.513a3.06 3.06 0 0 0 2.106-2.22c.505-1.958.505-6.043.505-6.043s.015-4.1-.505-6.073C23.6 1.816 22.783.962 21.76.682 19.876.14 12.354.14 12.354.14zM9.965 5.17l6.246 3.774-6.246 3.76V5.17z"
                    fill="currentColor"
                    fillRule="nonzero"
                />
                <path d="M-6-9h36v36H-6z" />
            </g>
        )
    },
    SOUNDTRACK: {
        viewBox: '0 0 16 16',
        data: (
            <path
                fill="currentColor"
                d="M15 0h1v11.5c0 1.381-1.567 2.5-3.5 2.5s-3.5-1.119-3.5-2.5c0-1.381 1.567-2.5 3.5-2.5 0.979 0 1.865 0.287 2.5 0.751v-5.751l-8 1.778v7.722c0 1.381-1.567 2.5-3.5 2.5s-3.5-1.119-3.5-2.5c0-1.381 1.567-2.5 3.5-2.5 0.979 0 1.865 0.287 2.5 0.751v-9.751l9-2z"
            />
        )
    },
    STEAM: {
        viewBox: '0 0 256 50',
        data: (
            <g fill="currentColor" fillRule="evenodd">
                <polygon points="246.1,47.4 237.6,47.4 237.6,20.1 227.6,37.9 221.9,37.9 213.4,20.1 213.4,47.4 203.4,47.4 203.4,0.4 213.4,0.4 224.8,25.8 237.6,0.4 246.1,0.4 246.1,47.4" />
                <path d="M173.5,0.4h-7.1l-17.1,47h10l2.8-8.3h15.7l2.8,8.3h10L173.5,0.4z M165,31.3l5.7-17.1l5.7,17.1H165z" />
                <polygon points="135.1,47.4 103.8,47.4 103.8,0.4 135.1,0.4 135.1,8.5 113.8,8.5 113.8,19.6 132.3,19.6 132.3,27.8 113.8,27.8 113.8,39.3 135.1,39.3" />
                <polygon points="89.6,8.5 78.2,8.5 78.2,47.4 68.2,47.4 68.2,8.5 55.4,8.5 55.4,0.4 89.6,0.4" />
                <path d="M44,33.6c0,9.7-8.5,14.1-17.1,14.2c-8.5,0-14.2-2-17.1-6.3l5.7-5.8c2.8,2.6,5.7,4,11.4,4c5.7,0,8.5-2,8.5-5.8c0-3.6-2.8-5.1-5.7-5.7l-5.7-0.7c-8.5-1.1-12.8-5.6-12.8-13.2c0-4.3,1.4-7.7,4.3-10.4C18.4,1.3,22.7,0,27,0c7.1,0,11.4,1.8,15.7,5.4l-5.7,5.8C34.1,9.1,31.2,8,27,8c-4.3,0.3-7.1,1.8-7.1,6c0,3.3,2.8,4.8,5.7,5.1l5.7,0.9C38.3,20.8,44,25.6,44,33.6z" />
            </g>
        )
    },
    STEAM_ROUND: {
        viewBox: '0 0 256 256',
        data: (
            <g fill="none" fillRule="evenodd">
                <circle className="background" fill="#2B3A4D" cx="128" cy="128" r="128" />
                <g className="foreground" fill="#FFF">
                    <path d="M202.433 142.937h-5.357v-17.206l-6.303 11.156h-3.592l-5.357-11.156v17.206h-6.303v-29.622h6.303l7.184 15.946 8.068-15.946h5.357z" />
                    <path
                        d="M156.676 113.315h-4.474l-10.778 29.622h6.303l1.765-5.231h9.895l1.764 5.231h6.303l-10.778-29.622zm-5.357 19.475l3.593-10.777 3.592 10.777h-7.185z"
                        fillRule="nonzero"
                    />
                    <path d="M132.475 142.937h-19.727v-29.622h19.727v5.105H119.05v6.996h11.66v5.105h-11.66v7.31h13.425zM103.798 118.42h-7.185v24.517h-6.302V118.42h-8.067v-5.105h21.554zM75.059 134.24c0 6.113-5.357 8.886-10.777 8.95-5.358 0-8.95-1.261-10.778-3.972l3.593-3.655c1.764 1.639 3.592 2.521 7.185 2.521 3.592 0 5.357-1.26 5.357-3.655 0-2.27-1.765-3.215-3.593-3.593l-3.592-.441c-5.357-.693-8.067-3.53-8.067-8.32 0-2.71.882-4.852 2.71-6.554 1.764-1.639 4.474-2.395 7.185-2.395 4.474 0 7.184 1.135 9.894 3.403l-3.592 3.656c-1.765-1.324-3.592-2.08-6.302-2.08-2.71.19-4.475 1.134-4.475 3.782 0 2.08 1.764 3.025 3.592 3.214l3.593.567c4.474.504 8.067 3.53 8.067 8.571z" />
                </g>
            </g>
        )
    },
    STORE: {
        viewBox: '0 0 19 19',
        data: (
            <path
                d="M7.8955149 18.7885276L.2119042 11.1049169c-.2825389-.2825389-.2825389-.7432948 0-1.0251093L9.9693938.3223181c.28109-.2818145.8186385-.4020747 1.1939082-.2666009l5.0400602 1.814045c.3745453.1354738.7918336.5520376.9265829.9273073l1.8147695 5.0400603c.1347493.3752697.0144891.9120937-.2666009 1.1939082l-9.758214 9.7574896c-.2818145.2818144-.7425704.2818144-1.0243848 0zM13.5 7c.8284271 0 1.5-.6715729 1.5-1.5S14.3284271 4 13.5 4 12 4.6715729 12 5.5 12.6715729 7 13.5 7z"
                fill="currentColor"
                fillRule="evenodd"
            />
        )
    },
    UNREAL: {
        viewBox: '0 0 22 19',
        data: (
            <path
                d="M10.299032 14.924125c.2066749.1834529.5304477.2742638.9714981.2742638.3581287 0 .7989993-.0979513 1.3227917-.2947695.5234326-.1968181.9373221-.4782223 1.2402296-.8442125V5.40398551c-.0552213-.30905026-.172499-.59759482-.352013-.86490133-.1800536-.26712342-.5460967-.51374113-1.0988488-.7391208.0550414 0 .1244726-.01336532.2073945-.04174375.0823821-.02856152.1933642-.04284228.3316872-.04284228.1933643 0 .4077738.04284228.6423292.12651288.2345554.08458603.4906956.23966042.7669817.46485699.2759263-.33761177.6214638-.68218085 1.0362527-1.03480573.4147889-.35170945.89775-.69646161 1.4508618-1.03480574.5527521-.33742869 1.174036-.63311363 1.8654708-.88613937.6912548-.25302575 1.464712-.43629549 2.3221702-.54944303-.3316872.16917206-.6694901.37404602-1.0143081.61279101-.344818.23947733-.6765052.52802189-.9932629.86545058-.317837.33852722-.6004186.72502313-.8490042 1.16131861-.2484056.43647857-.4277398.95021971-.5381823 1.54067415v9.1622051c.0552213.1406106.1444387.2537581.2687314.3383442.1242928.084586.310642.1263297.5592275.1263297.3034471 0 .7455768-.1541589 1.3249502-.4639415.5793734-.3099657 1.3249501-.9147009 2.2360107-1.814938-.2216045.6481268-.732446 1.5137604-1.5341433 2.5976334-.8013376 1.0836899-2.1270072 2.244093-3.9784479 3.4813926-.3047061-.1122321-.6633744-.2878122-1.0779834-.5265572-.4147889-.238745-.7885666-.6679001-1.1193544-1.2876484-.5527521.5628084-1.0857181 1.0694091-1.5965595 1.519253-.5112013.4505763-.8637538.7455289-1.0571181.8861394-.6088727-.0836706-1.2580371-.1896778-1.94929198-.3161906-.69125487-.1265129-1.36847958-.3097827-2.03167414-.5485276-.66337443-.238745-1.27134774-.5415703-1.82445956-.9075606-.55293194-.3652578-.99560127-.8158341-1.32638912-1.3509963.08220231.084586.28959676.1265128.62128398.1265128.19336429 0 .37971351-.0490672.55994702-.147934.17933414-.0979513.31064198-.3161906.39374366-.6545347V7.60322233c0-.22446424-.0760866-.44270352-.22754031-.65380243-.1521732-.21018347-.37971351-.31619064-.68262092-.31619064-.16548386 0-.43421526.07030528-.8061942.21109891-.37287831.14061054-.79989862.42128238-1.28232005.84348019-.48296105.42219781-.99254341 1.02766535-1.52982634 1.81493794C1.01340877 10.290202.49627171 11.3169519 0 12.5826299c.05504137-.8442125.24157046-1.8220783.55922752-2.93432971.31765707-1.11151905.85655886-2.24519157 1.61688524-3.39918671.7596069-1.15417823 1.80970992-2.27997803 3.15012919-3.37794866C6.66666122 1.77319419 8.38697387.8158341 10.487 0c-.4147889.22537966-.7462962.45057624-.99488174.67504047-.24858554.22537967-.46983027.49964346-.66319456.82388992-.19354417.32406337-.28977663.69646161-.28977663 1.11847633 0 .08458603.00629558.21823929.02014586.40150902.01403016.18345282.0692514.38027097.16620336.59136988.09641233.2110989.23455538.40077667.41478889.56994873.17933414.16917206.43493476.26730651.76662197.29495259v9.79513566c.05432188.2530258.18544985.4712651.39212485.6538024z"
                fill="currentColor"
                fillRule="evenodd"
            />
        )
    },
    USER: {
        viewBox: '0 0 20 20',
        data: (
            <path
                d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2a7.2 7.2 0 0 1-6-3.22c.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08a7.2 7.2 0 0 1-6 3.22z"
                fill="currentColor"
                fillRule="nonzero"
            />
        )
    },
    USER_EMPTY: {
        viewBox: '0 0 200 200',
        data: (
            <>
                <path
                    fill="currentColor"
                    d="M124.53,125.46c0-21.86,25.85-30.93,25.85-64.08,0-29.67-21.72-53.73-48.52-53.73H98.14c-26.8,0-48.52,24.06-48.52,53.73,0,33.15,25.85,42.22,25.85,64.08,0,11.92-38.7,28.78-38.7,42,0,9.22,7.4,18.29,33.62,18.29h59.22c26.22,0,33.62-9.07,33.62-18.29C163.23,154.24,124.53,137.38,124.53,125.46Z"
                />
            </>
        )
    },
    USER_ONLINE: {
        viewBox: '0 0 200 200',
        data: (
            <>
                <path
                    fill="currentColor"
                    d="M124.53,125.46c0-21.86,25.85-30.93,25.85-64.08,0-29.67-21.72-53.73-48.52-53.73H98.14c-26.8,0-48.52,24.06-48.52,53.73,0,33.15,25.85,42.22,25.85,64.08,0,11.92-38.7,28.78-38.7,42,0,9.22,7.4,18.29,33.62,18.29h59.22c26.22,0,33.62-9.07,33.62-18.29C163.23,154.24,124.53,137.38,124.53,125.46Z"
                />
                <ellipse
                    fill="#52971c"
                    cx="143.9"
                    cy="164.43"
                    rx="33.99"
                    ry="33.91"
                    transform="translate(-74.11 149.73) rotate(-44.95)"
                />
            </>
        )
    },
    VK: {
        viewBox: '0 0 37 21',
        data: (
            <path
                fill="currentColor"
                d="M36.804 18.965a2.516 2.516 0 0 0-.126-.24c-.642-1.15-1.868-2.561-3.68-4.235l-.037-.038-.02-.019-.019-.02h-.02c-.821-.779-1.342-1.303-1.56-1.57-.398-.512-.488-1.03-.27-1.553.154-.396.733-1.233 1.734-2.51.527-.678.944-1.22 1.252-1.63 2.222-2.938 3.185-4.816 2.89-5.634l-.115-.19c-.077-.116-.276-.22-.597-.317-.321-.096-.732-.112-1.233-.048L29.455 1c-.09-.031-.218-.028-.385.01l-.25.058-.097.048-.077.057a.854.854 0 0 0-.212.201 1.304 1.304 0 0 0-.192.336 31.22 31.22 0 0 1-2.062 4.31 40.795 40.795 0 0 1-1.31 2.06c-.398.58-.732 1.009-1.001 1.284-.27.274-.514.494-.733.66-.218.167-.385.237-.5.211a14.178 14.178 0 0 1-.328-.076 1.277 1.277 0 0 1-.433-.47 2.094 2.094 0 0 1-.222-.747 8.198 8.198 0 0 1-.067-.776 16.13 16.13 0 0 1 .01-.92c.013-.397.019-.665.019-.805 0-.486.01-1.013.028-1.581.02-.569.035-1.02.049-1.351.013-.332.019-.684.019-1.054s-.023-.661-.068-.872a2.972 2.972 0 0 0-.201-.614 1.034 1.034 0 0 0-.395-.46A2.233 2.233 0 0 0 20.4.253C19.72.1 18.853.017 17.8.003c-2.39-.025-3.924.129-4.605.46-.27.141-.514.333-.732.576-.231.28-.263.434-.096.46.77.114 1.316.389 1.637.823l.116.23c.09.167.18.46.27.882.09.422.147.888.173 1.399.064.932.064 1.731 0 2.395a28.397 28.397 0 0 1-.183 1.553c-.058.37-.145.67-.26.9-.116.23-.193.37-.231.422a.33.33 0 0 1-.097.095 1.45 1.45 0 0 1-.52.097c-.18 0-.398-.09-.655-.269a4.612 4.612 0 0 1-.8-.738c-.275-.313-.587-.75-.934-1.313a22.869 22.869 0 0 1-1.078-1.992l-.309-.556a47.708 47.708 0 0 1-.79-1.562 30.035 30.035 0 0 1-.885-1.984 1.264 1.264 0 0 0-.463-.613l-.096-.058a1.32 1.32 0 0 0-.308-.162 2.053 2.053 0 0 0-.443-.125L1.233.96c-.54 0-.905.122-1.098.365l-.077.114C.019 1.503 0 1.606 0 1.746c0 .14.039.313.116.517A63.1 63.1 0 0 0 2.63 7.476c.905 1.674 1.692 3.022 2.36 4.043a47.742 47.742 0 0 0 2.041 2.894c.694.907 1.153 1.489 1.378 1.744.225.256.401.447.53.575l.481.46c.308.306.761.674 1.358 1.102.598.428 1.259.85 1.985 1.265.725.415 1.57.753 2.533 1.015.963.262 1.9.367 2.813.317h2.215c.45-.039.79-.18 1.021-.422l.077-.096c.051-.076.1-.195.144-.354.045-.16.068-.336.068-.527a6.283 6.283 0 0 1 .124-1.485c.096-.44.206-.773.328-.997a2.45 2.45 0 0 1 .414-.565c.154-.153.264-.246.328-.278a1.26 1.26 0 0 1 .154-.067c.308-.102.671-.003 1.089.297.417.3.809.671 1.175 1.112.366.441.806.936 1.32 1.485.513.55.963.958 1.348 1.227l.385.23c.257.153.591.294 1.002.421.41.128.77.16 1.079.096l4.931-.076c.488 0 .868-.08 1.137-.24.27-.16.43-.336.481-.527.052-.192.055-.41.01-.652a2.395 2.395 0 0 0-.135-.508z"
            />
        )
    },
    VOLUME_HIGH: {
        viewBox: '0 0 18 18',
        data: (
            <path
                d="M0 6v6h4l5 5V1L4 6H0zm13.5 3A4.5 4.5 0 0 0 11 4.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM11 .23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77 0-4.28-2.99-7.86-7-8.77z"
                fill="currentColor"
                fillRule="nonzero"
            />
        )
    },
    VOLUME_LOW: {
        viewBox: '0 0 18 18',
        data: <path d="M0 6v6h4l5 5V1L4 6H0z" fill="currentColor" />
    },
    VOLUME_MEDIUM: {
        viewBox: '0 0 18 18',
        data: (
            <path
                d="M13.5 9A4.5 4.5 0 0 0 11 4.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM0 6v6h4l5 5V1L4 6H0z"
                fill="currentColor"
                fillRule="nonzero"
            />
        )
    },
    VOLUME_MUTE: {
        viewBox: '0 0 18 18',
        data: (
            <path
                d="M13.5 9A4.5 4.5 0 0 0 11 4.97v2.21l2.45 2.45c.03-.2.05-.41.05-.63zM16 9c0 .94-.2 1.82-.54 2.64l1.51 1.51A8.796 8.796 0 0 0 18 9c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM1.27 0L0 1.27 4.73 6H0v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06a8.99 8.99 0 0 0 3.69-1.81L16.73 18 18 16.73l-9-9L1.27 0zM9 1L6.91 3.09 9 5.18V1z"
                fill="currentColor"
                fillRule="nonzero"
            />
        )
    },
    WARNING: {
        viewBox: '0 0 20 18',
        data: (
            <g fill="none" fillRule="evenodd">
                <path
                    className="background"
                    d="M11.461.845a1.69 1.69 0 0 0-2.926 0L.226 15.243a1.691 1.691 0 0 0 1.463 2.535h16.622a1.69 1.69 0 0 0 1.398-2.638L11.46.845z"
                    fill="#e08220"
                    fillRule="nonzero"
                />
                <path
                    className="foreground"
                    d="M11.111 9.235l-.667 3.261h-.93l-.625-3.173V6.667h2.222v2.568zm0 6.32H8.89v-2.14h2.222v2.14z"
                    fill="#fff"
                />
            </g>
        )
    },
    XBOX: {
        viewBox: '0 0 26 26',
        data: (
            <path
                d="M11.73 25.7c-1.97-.19-3.96-.9-5.67-2-1.43-.94-1.75-1.32-1.75-2.09 0-1.54 1.69-4.23 4.59-7.3 1.64-1.75 3.93-3.8 4.18-3.74.48.1 4.33 3.86 5.78 5.63 2.28 2.8 3.32 5.08 2.8 6.1-.41.78-2.93 2.3-4.77 2.88a14 14 0 0 1-5.16.52zm-9.36-5.69A13.22 13.22 0 0 1 .3 13.8c-.1-.86-.06-1.35.22-3.1.35-2.2 1.6-4.74 3.1-6.3.64-.67.7-.69 1.48-.42.94.32 1.96 1.01 3.52 2.43l.92.83-.5.61c-2.32 2.85-4.77 6.9-5.7 9.39-.5 1.36-.7 2.72-.48 3.29.14.38.01.24-.48-.5zm20.9.31a6.19 6.19 0 0 0-.39-2.69c-.75-2.3-3.28-6.58-5.6-9.49l-.72-.92.79-.72a16.66 16.66 0 0 1 2.51-2c.61-.37 1.48-.7 1.86-.7.23 0 1.04.83 1.7 1.75a13.35 13.35 0 0 1 2.14 4.95c.24 1.16.26 3.64.04 4.8-.19.95-.58 2.18-.96 3.02-.29.63-1 1.84-1.3 2.24-.17.2-.17.2-.08-.24zM11.93 3.36A15.88 15.88 0 0 0 8.3 2.08 6.65 6.65 0 0 0 7.1 2c-.75.04-.72 0 .48-.57 1-.48 1.84-.75 2.98-1 1.27-.26 3.67-.26 4.93 0 1.36.29 2.96.88 3.86 1.44l.26.16-.61-.03c-1.22-.06-3 .43-4.9 1.36-.58.28-1.08.5-1.12.5l-1.04-.51z"
                fill="currentColor"
                fillRule="nonzero"
            />
        )
    },

    /*** Dev Portal Icons ***/
    SPHERE: {
        viewBox: '0 0 500 500',
        data: (
            <g>
                <path
                    fill="#f5f5f5"
                    stroke="null"
                    d="M255.5 1C114.392 1 0 115.392 0 256.5S114.392 512 255.5 512C396.61 512 511 397.61 511 256.5S396.61 1 255.5 1zm144.565 340.667c4.567-21.534 7.45-44.39 8.388-68.134h67.838a219.215 219.215 0 0 1-16.33 68.134h-59.896zm-289.13-170.334c-4.567 21.534-7.45 44.39-8.388 68.134H34.71a219.22 219.22 0 0 1 16.33-68.134h59.895zm254.236 0c5.118 21.804 8.196 44.635 9.198 68.134H272.533v-68.134h92.638zm-92.638-34.066V37.548c7.766 2.26 15.46 6.052 23.01 11.375 14.15 9.975 27.686 25.342 39.145 44.44 7.922 13.201 14.772 27.9 20.491 43.905h-82.646v-.001zM176.312 93.36c11.46-19.097 24.994-34.465 39.145-44.439 7.549-5.323 15.244-9.115 23.01-11.375v99.72H155.82c5.72-16.004 12.57-30.703 20.491-43.906zm62.155 77.972v68.134H136.632c1-23.499 4.08-46.33 9.197-68.134h92.638zM51.04 341.667a219.213 219.213 0 0 1-16.33-68.134h67.838c.938 23.745 3.82 46.6 8.388 68.134H51.04zm85.592-68.134h101.835v68.134h-92.638c-5.117-21.803-8.196-44.635-9.197-68.134zm101.835 102.2v99.72c-7.765-2.26-15.46-6.053-23.01-11.375-14.15-9.975-27.687-25.343-39.145-44.44-7.922-13.202-14.771-27.9-20.492-43.905h82.647zm96.221 43.906c-11.46 19.096-24.995 34.464-39.145 44.439-7.55 5.322-15.244 9.115-23.01 11.375v-99.72h82.647c-5.72 16.004-12.57 30.703-20.492 43.906zm-62.155-77.972v-68.134h101.835c-1 23.499-4.08 46.331-9.198 68.134h-92.637zm135.92-102.2c-.938-23.745-3.82-46.6-8.388-68.134h59.896a219.222 219.222 0 0 1 16.33 68.134h-67.838zm33.7-102.2h-51.047c-9.921-31.279-23.621-58.709-40.09-80.604 22.641 10.827 43.146 25.345 61.06 43.26 11.434 11.433 21.485 23.92 30.076 37.344zM98.922 99.923c17.916-17.916 38.421-32.433 61.062-43.26-16.47 21.895-30.169 49.325-40.09 80.604H68.848c8.59-13.424 18.642-25.911 30.074-37.344zM68.85 375.733h51.045c9.922 31.279 23.621 58.709 40.092 80.605-22.642-10.827-43.147-25.345-61.062-43.261-11.433-11.433-21.485-23.92-30.075-37.344zm343.228 37.344c-17.915 17.916-38.421 32.434-61.062 43.261 16.47-21.895 30.17-49.326 40.09-80.605h51.047c-8.59 13.424-18.642 25.911-30.075 37.344z"
                />
            </g>
        )
    },
    DEV_PORTAL: {
        viewBox: '0 0 21.556 13.557',
        data: (
            <g
                transform="translate(-66.672 -373.671)"
                stroke="currentColor"
                strokeWidth="3"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10">
                <path d="M8,0V8H0" transform="translate(75.793 381.449) rotate(-45)" />
                <path d="M8,0V8H0" transform="translate(80.107 381.449) rotate(135)" />
            </g>
        )
    },
    MAC: {
        viewBox: '0 0 512 512',
        data: (
            <g>
                <path
                    fill="currentColor"
                    d="M395.749 272.046c-0.647-64.841 52.879-95.938 55.271-97.483-30.076-44.010-76.925-50.039-93.621-50.736-39.871-4.037-77.798 23.474-98.033 23.474-20.184 0-51.409-22.877-84.476-22.276-43.458 0.646-83.529 25.269-105.906 64.19-45.152 78.349-11.563 194.42 32.445 257.963 21.504 31.102 47.146 66.038 80.813 64.79 32.421-1.294 44.681-20.979 83.878-20.979s50.214 20.979 84.525 20.335c34.887-0.648 56.991-31.699 78.346-62.898 24.695-36.084 34.863-71.019 35.462-72.813-0.774-0.353-68.030-26.118-68.704-103.567zM331.281 81.761c17.869-21.679 29.93-51.756 26.64-81.761-25.739 1.048-56.939 17.145-75.405 38.775-16.571 19.188-31.074 49.813-27.187 79.218 28.733 2.242 58.064-14.602 75.952-36.232z"
                />
            </g>
        )
    },
    ANDROID: {
        viewBox: '0 0 512 512',
        data: (
            <g>
                <path
                    fill="currentColor"
                    d="M448 192c-17.6 0-32 14.4-32 32v128c0 17.6 14.4 32 32 32s32-14.4 32-32v-128c0-17.6-14.4-32-32-32zM64 192c-17.6 0-32 14.4-32 32v128c0 17.6 14.4 32 32 32s32-14.4 32-32v-128c0-17.6-14.401-32-32-32zM112 368c0 26.51 21.49 48 48 48v0 64c0 17.6 14.4 32 32 32s32-14.4 32-32v-64h64v64c0 17.6 14.4 32 32 32s32-14.4 32-32v-64c26.51 0 48-21.49 48-48v-176h-288v176z"
                />
                <path
                    fill="currentColor"
                    d="M399.108 160.001c-4.858-43.942-29.502-81.896-64.81-104.823l16.012-32.023c3.952-7.903 0.748-17.514-7.155-21.466s-17.515-0.748-21.466 7.156l-16.071 32.143-4.175-1.658c-14.284-4.751-29.561-7.33-45.443-7.33-15.881 0-31.158 2.579-45.444 7.328l-4.174 1.658-16.071-32.141c-3.952-7.904-13.564-11.106-21.466-7.156-7.904 3.952-11.107 13.563-7.156 21.466l16.011 32.023c-35.308 22.926-59.952 60.881-64.811 104.822v16h287.111v-15.999h-0.892zM208 128c-8.837 0-16-7.164-16-16 0-8.824 7.144-15.979 15.965-15.998 0.016 0 0.031 0.001 0.047 0.001 0.009 0 0.018-0.001 0.026-0.001 8.819 0.021 15.962 7.175 15.962 15.998 0 8.836-7.163 16-16 16zM304 128c-8.837 0-16-7.164-16-16 0-8.823 7.143-15.977 15.962-15.998 0.008 0 0.017 0.001 0.025 0.001 0.016 0 0.032-0.001 0.048-0.001 8.82 0.019 15.965 7.174 15.965 15.998 0 8.836-7.163 16-16 16z"
                />
            </g>
        )
    },
    WINDOWS: {
        viewBox: '0 0 512 512',
        data: (
            <g>
                <path
                    fill="currentColor"
                    d="M0.175 256l-0.175-156.037 192-26.072v182.109zM224 69.241l255.936-37.241v224h-255.936zM479.999 288l-0.063 224-255.936-36.008v-187.992zM192 471.918l-191.844-26.297-0.010-157.621h191.854z"
                />
            </g>
        )
    },
    WIN32: {
        viewBox: '0 0 512 512',
        data: (
            <g>
                <path
                    fill="currentColor"
                    d="M206.115 255.957c-23.854-12.259-47.043-18.479-68.94-18.479-2.978 0-5.976 0.090-8.974 0.354-27.94 2.312-53.461 9.684-69.875 15.414-4.354 1.599-8.817 3.288-13.415 5.153l-44.911 155.697c30.851-11.416 58.146-16.969 83.135-16.969 40.423 0 69.764 15.104 93.996 30.652 11.481-38.959 39.022-133.045 47.241-161.162-5.975-3.642-12.038-7.285-18.257-10.66zM264.174 295.535l-45.223 157.074c13.416 7.686 58.549 32.025 93.106 32.025 27.896 0 59.126-7.148 95.417-21.896l43.178-150.988c-29.316 9.461-57.438 14.26-83.732 14.26-47.975 0-81.557-15.549-102.746-30.475zM146.411 184.395c38.559 0.399 67.076 15.104 90.708 30.251l46.376-158.672c-9.773-5.598-35.403-19.547-53.929-24.3-12.193-2.842-25.010-4.308-38.602-4.308-25.898 0.488-54.194 6.973-86.444 19.9l-44.22 155.298c32.404-12.218 60.322-18.17 86.043-18.17 0.023 0.001 0.068 0.001 0.068 0.001zM512 99.062c-29.407 11.416-58.104 17.233-85.514 17.233-45.843 0-79.646-15.901-101.547-31.183l-45.975 159.118c30.873 19.854 64.145 29.939 99.061 29.939 28.474 0 57.97-6.84 87.731-20.344l-0.091-1.111 1.867-0.443 44.468-153.209z"
                />
            </g>
        )
    },
    BUILD: {
        viewBox: '0 0 768 768',
        data: (
            <g>
                <path
                    fill="currentColor"
                    d="M528 288h175.5v192h-175.5l-96-96zM288 528l96-96 96 96v175.5h-192v-175.5zM240 288l96 96-96 96h-175.5v-192h175.5zM480 240l-96 96-96-96v-175.5h192v175.5z"
                />
            </g>
        )
    },
    DICE: {
        viewBox: '0 0 448 512',
        data: (
            <g>
                <path
                    fill="currentColor"
                    d="M422.19 109.95L256.21 9.07c-19.91-12.1-44.52-12.1-64.43 0L25.81 109.95c-5.32 3.23-5.29 11.27.06 14.46L224 242.55l198.14-118.14c5.35-3.19 5.38-11.22.05-14.46zm13.84 44.63L240 271.46v223.82c0 12.88 13.39 20.91 24.05 14.43l152.16-92.48c19.68-11.96 31.79-33.94 31.79-57.7v-197.7c0-6.41-6.64-10.43-11.97-7.25zM0 161.83v197.7c0 23.77 12.11 45.74 31.79 57.7l152.16 92.47c10.67 6.48 24.05-1.54 24.05-14.43V271.46L11.97 154.58C6.64 151.4 0 155.42 0 161.83z"
                />
            </g>
        )
    },
    INSTALL: {
        viewBox: '0 0 512 512',
        data: (
            <g>
                <circle
                    cx="256"
                    cy="256"
                    r="250"
                    stroke="currentColor"
                    strokeWidth="6"
                    fill="none"
                />
                <path
                    fill="currentColor"
                    d="m325.500007,274.934379l-51.200003,51.200003l-12.000001,-12.000001l30.800002,-30.800002l-95.600005,0l0,-102.400005l17.200001,0l0,85.600005l78.400004,0l-30.800002,-30.800002l12.000001,-12.000001l51.200003,51.200003z"
                />
            </g>
        )
    },
    TRIPLE: {
        viewBox: '0 0 512 512',
        data: (
            <g>
                <path
                    fill="currentColor"
                    stroke="null"
                    d="m260.500003,316.500014c-33.413017,0 -60.500003,-27.086986 -60.500003,-60.500003s27.086986,-60.500003 60.500003,-60.500003l0,0c33.413017,0 60.500003,27.086986 60.500003,60.500003s-27.086986,60.500003 -60.500003,60.500003l0,0zm0,-181.500009c-33.413017,0 -60.500003,-27.086986 -60.500003,-60.500003s27.086986,-60.500003 60.500003,-60.500003l0,0c33.413017,0 60.500003,27.086986 60.500003,60.500003s-27.086986,60.500003 -60.500003,60.500003l0,0zm0,363.000017c-33.413017,0 -60.500003,-27.086986 -60.500003,-60.500003s27.086986,-60.500003 60.500003,-60.500003l0,0c33.413017,0 60.500003,27.086986 60.500003,60.500003s-27.086986,60.500003 -60.500003,60.500003l0,0z"
                />
            </g>
        )
    },
    PAPER: {
        viewBox: '0 0 10 13',
        data: <path fill="currentColor" d="M10,13H0V0H5.75L10,3.964V13ZM4.75,1V4.964H9Z" />
    },
    BAR: {
        viewBox: '0 0 10.763 12.721',
        data: (
            <Fragment>
                <rect
                    fill="currentColor"
                    width="8.806"
                    height="2.935"
                    transform="translate(0 9.785)"
                />
                <rect
                    fill="currentColor"
                    width="10.763"
                    height="2.935"
                    transform="translate(0 4.892)"
                />
                <rect fill="currentColor" width="4.892" height="2.935" transform="translate(0)" />
            </Fragment>
        )
    },

    /*** Affiliate specific icons ***/

    ARROW_LEFT: {
        viewBox: '0 0 1600 1200',
        data: (
            <Fragment>
                <path
                    d="M269.81 520.556L699.3 250.733 599.266 187.89-1 565l600.267 377.111 100.032-62.844-429.49-269.823h1144.08v-88.888H269.809z"
                    fill="currentColor"
                    stroke="none"
                />
            </Fragment>
        )
    },
    CARET_DOWN: {
        viewBox: '0 0 448 448',
        data: (
            <Fragment>
                <path fill="none" d="M-1-1h450v450H-1z" />
                <path
                    stroke="none"
                    fill="currentColor"
                    d="M441.11 165.015c0 4.785-1.97 9.288-5.346 12.666L309.667 303.778c-3.378 3.377-7.88 5.346-12.666 5.346s-9.287-1.97-12.665-5.346L158.239 177.68c-3.377-3.378-5.347-7.88-5.347-12.666 0-9.85 8.163-18.013 18.013-18.013H423.1c9.85 0 18.013 8.163 18.013 18.013h-.003z"
                />
                <path
                    stroke="none"
                    strokeWidth="none"
                    fill="currentColor"
                    d="M10.5 11h22v426h-22z"
                />
            </Fragment>
        )
    },
    EYE: {
        viewBox: '0 0 512 512',
        data: (
            <Fragment>
                <path
                    fill="currentColor"
                    d="M510.096,249.937c-4.032-5.867-100.928-143.275-254.101-143.275C124.56,106.662,7.44,243.281,2.512,249.105
			c-3.349,3.968-3.349,9.792,0,13.781C7.44,268.71,124.56,405.329,255.995,405.329S504.549,268.71,509.477,262.886
			C512.571,259.217,512.848,253.905,510.096,249.937z M255.995,383.996c-105.365,0-205.547-100.48-230.997-128
			c25.408-27.541,125.483-128,230.997-128c123.285,0,210.304,100.331,231.552,127.424
			C463.013,282.065,362.256,383.996,255.995,383.996z"/>
                <path
                    fill="currentColor"
                    d="M255.995,170.662c-47.061,0-85.333,38.272-85.333,85.333s38.272,85.333,85.333,85.333s85.333-38.272,85.333-85.333
			S303.056,170.662,255.995,170.662z M255.995,319.996c-35.285,0-64-28.715-64-64s28.715-64,64-64s64,28.715,64,64
			S291.28,319.996,255.995,319.996z"/>
            </Fragment>
        )
    },
    EYE_CLOSED: {
        viewBox: '0 0 512 512',
        data: (
            <Fragment>
                <path
                    fill="currentColor"
                    d="M316.332,195.662c-4.16-4.16-10.923-4.16-15.083,0c-4.16,4.16-4.16,10.944,0,15.083
			c12.075,12.075,18.752,28.139,18.752,45.248c0,35.285-28.715,64-64,64c-17.109,0-33.173-6.656-45.248-18.752
			c-4.16-4.16-10.923-4.16-15.083,0c-4.16,4.139-4.16,10.923,0,15.083c16.085,16.128,37.525,25.003,60.331,25.003
			c47.061,0,85.333-38.272,85.333-85.333C341.334,233.187,332.46,211.747,316.332,195.662z"/>
                <path
                    fill="currentColor"
                    d="M270.87,172.131c-4.843-0.853-9.792-1.472-14.869-1.472c-47.061,0-85.333,38.272-85.333,85.333
			c0,5.077,0.619,10.027,1.493,14.869c0.917,5.163,5.419,8.811,10.475,8.811c0.619,0,1.237-0.043,1.877-0.171
			c5.781-1.024,9.664-6.571,8.64-12.352c-0.661-3.627-1.152-7.317-1.152-11.157c0-35.285,28.715-64,64-64
			c3.84,0,7.531,0.491,11.157,1.131c5.675,1.152,11.328-2.859,12.352-8.64C280.534,178.702,276.652,173.155,270.87,172.131z"/>
                <path
                    fill="currentColor"
                    d="M509.462,249.102c-2.411-2.859-60.117-70.208-139.712-111.445c-5.163-2.709-11.669-0.661-14.379,4.587
			c-2.709,5.227-0.661,11.669,4.587,14.379c61.312,31.744,110.293,81.28,127.04,99.371c-25.429,27.541-125.504,128-230.997,128
			c-35.797,0-71.872-8.64-107.264-25.707c-5.248-2.581-11.669-0.341-14.229,4.971c-2.581,5.291-0.341,11.669,4.971,14.229
			c38.293,18.496,77.504,27.84,116.523,27.84c131.435,0,248.555-136.619,253.483-142.443
			C512.854,258.915,512.833,253.091,509.462,249.102z"/>
                <path
                    fill="currentColor"
                    d="M325.996,118.947c-24.277-8.171-47.829-12.288-69.995-12.288c-131.435,0-248.555,136.619-253.483,142.443
			c-3.115,3.669-3.371,9.003-0.597,12.992c1.472,2.112,36.736,52.181,97.856,92.779c1.813,1.216,3.84,1.792,5.888,1.792
			c3.435,0,6.827-1.664,8.875-4.8c3.264-4.885,1.92-11.52-2.987-14.763c-44.885-29.845-75.605-65.877-87.104-80.533
			c24.555-26.667,125.291-128.576,231.552-128.576c19.861,0,41.131,3.755,63.189,11.157c5.589,2.005,11.648-1.088,13.504-6.699
			C334.572,126.862,331.585,120.825,325.996,118.947z"/>
                <path
                    fill="currentColor"
                    d="M444.865,67.128c-4.16-4.16-10.923-4.16-15.083,0L67.116,429.795c-4.16,4.16-4.16,10.923,0,15.083
			c2.091,2.069,4.821,3.115,7.552,3.115c2.731,0,5.461-1.045,7.531-3.115L444.865,82.211
			C449.025,78.051,449.025,71.288,444.865,67.128z"/>
            </Fragment>
        )
    },
    STEP_CHECKED: {
        viewBox: "0 0 515.556 515.556",
        data: (
            <Fragment>
                <path
                    fill="currentColor"
                    d="m0 274.226 176.549 176.886 339.007-338.672-48.67-47.997-290.337 290-128.553-128.552z"/>
            </Fragment>
        )
    },
    CHECKED: {
        viewBox: '0 0 664 664',
        data: (
            <Fragment>
                <path
                    fill="currentColor"
                    d="M21.9 22.9L19 25.8v603.4l2.9 2.9 2.9 2.9h603.4l2.9-2.9 2.9-2.9V25.8l-2.9-2.9-2.9-2.9H24.8l-2.9 2.9zm605.7 4.2c1.9 2.1 1.9 8.5 1.9 300.4s0 298.3-1.9 300.4l-1.9 2.1h-299c-276.9 0-299.2-.1-300.9-1.7-1.7-1.6-1.8-12.2-1.8-300.6 0-276.9.1-299.2 1.7-300.9 1.6-1.7 12.2-1.8 300.8-1.8h299.2l1.9 2.1z"
                    strokeWidth="5%"
                    stroke="currentColor"
                />
                <path
                    fill="#007deb"
                    d="M541.3 113.1c-2.3.4-5.6 1.5-7.4 2.5-1.8.9-30.3 28.5-63.3 61.3C356 290.5 291.4 354.6 271 374.8L250.4 395 190 334.4c-41.9-42.1-61.7-61.3-64.5-62.5-5.4-2.5-13.8-2.4-19.5.2-5.5 2.4-51.7 47.9-55.8 54.9-3.4 5.7-3.7 15.3-.7 21.5 1.3 2.6 25.4 27.6 70.6 73 37.7 37.9 78.7 79.3 91 91.9 12.3 12.6 24.2 24 26.4 25.4 3 1.9 5.7 2.6 11 3 11.6.7 11.3.9 66.8-54.2 27-27 73.5-73.1 103.2-102.6C559.6 245.1 610 194.5 611.6 191.1c2.4-5 2.9-11.3 1.3-16.8-1.1-4.2-3.7-7.3-19.8-23.8-10.3-10.5-21.5-22.1-25-25.8-9.3-9.6-17.7-13.3-26.8-11.6z"
                />
            </Fragment>
        )
    },
    UNCHECKED: {
        viewBox: '0 0 664 664',
        data: (
            <Fragment>
                <path
                    fill="currentColor"
                    d="M21.9 22.9L19 25.8v603.4l2.9 2.9 2.9 2.9h603.4l2.9-2.9 2.9-2.9V25.8l-2.9-2.9-2.9-2.9H24.8l-2.9 2.9zm605.7 4.2c1.9 2.1 1.9 8.5 1.9 300.4s0 298.3-1.9 300.4l-1.9 2.1h-299c-276.9 0-299.2-.1-300.9-1.7-1.7-1.6-1.8-12.2-1.8-300.6 0-276.9.1-299.2 1.7-300.9 1.6-1.7 12.2-1.8 300.8-1.8h299.2l1.9 2.1z"
                    strokeWidth="5%"
                    stroke="currentColor"
                />
            </Fragment>
        )
    },
    CHEVRON_DOWN: {
        viewBox: '0 0 1024 1024',
        data: (
            <path
                fill="currentColor"
                d="M255.583 340.917c-23.562.006-42.66 19.108-42.66 42.671 0 11.987 4.942 22.819 12.9 30.57l256.009 256.009c7.721 7.718 18.387 12.492 30.167 12.492s22.445-4.774 30.167-12.492l256-256c8.091-7.778 13.118-18.692 13.118-30.781 0-23.567-19.104-42.671-42.671-42.671-12.089 0-23.003 5.027-30.767 13.104l-.013.014L512 579.666 286.167 353.833c-7.76-7.971-18.594-12.916-30.583-12.917z"
            />
        )
    },
    CIRCLE: {
        viewBox: '0 0 384 448',
        data: (
            <Fragment>
                <path fill="none" d="M-1-1h582v402H-1z" />
                <path
                    fill="currentColor"
                    d="M192 88c-75 0-136 61-136 136s61 136 136 136 136-61 136-136S267 88 192 88zm192 136c0 106-86 192-192 192S0 330 0 224 86 32 192 32s192 86 192 192z"
                />
                <ellipse
                    stroke="none"
                    ry="95.5"
                    rx="95.5"
                    cy="226.5"
                    cx="194"
                    strokeOpacity="none"
                    strokeWidth="none"
                    fill="#007deb"
                />
            </Fragment>
        )
    },
    CIRCLE_EMPTY: {
        viewBox: '0 0 384 448',
        data: (
            <Fragment>
                <path fill="none" d="M-1-1h582v402H-1z" />
                <path
                    fill="currentColor"
                    d="M192 88c-75 0-136 61-136 136s61 136 136 136 136-61 136-136S267 88 192 88zm192 136c0 106-86 192-192 192S0 330 0 224 86 32 192 32s192 86 192 192z"
                />
            </Fragment>
        )
    },
    DOWNLOAD_ARROW: {
        viewBox: '0 0 1024 1024',
        data: (
            <Fragment>
                <path fill="none" d="M-1-1h582v402H-1z" />
                <path
                    fill="currentColor"
                    d="M511.333 85.433c-23.278.375-42.004 19.334-42.004 42.666 0 .205.001.411.004.615v-.03 597.332c-.003.18-.004.391-.004.603 0 23.567 19.104 42.671 42.671 42.671s42.671-19.104 42.671-42.67c0-.213-.002-.425-.005-.636v.032-597.333c.003-.174.004-.379.004-.584 0-23.567-19.104-42.67-42.671-42.67-.234 0-.468.001-.702.005H511.333z"
                />
                <path
                    fill="currentColor"
                    d="M212.917 386.267c-23.562.006-42.66 19.108-42.66 42.671 0 11.987 4.942 22.82 12.9 30.57l298.676 298.676c7.721 7.718 18.387 12.492 30.167 12.492s22.445-4.774 30.167-12.492l298.666-298.666c8.092-7.778 13.118-18.692 13.118-30.78 0-23.568-19.104-42.672-42.671-42.672-12.089 0-23.003 5.027-30.767 13.104l-.013.014-268.5 268.5-268.5-268.5c-7.76-7.97-18.594-12.916-30.583-12.917zM173.385 906.987c.375 23.278 19.334 42.004 42.666 42.004.205 0 .411-.001.615-.004h-.03 597.332c.179.003.391.004.603.004 23.567 0 42.671-19.104 42.671-42.671s-19.104-42.671-42.67-42.671c-.213 0-.425.002-.636.005h.032-597.333a35.461 35.461 0 0 0-.584-.004c-23.567 0-42.67 19.104-42.67 42.67 0 .235.001.469.005.703V906.987z"
                />
            </Fragment>
        )
    },
    INFO: {
        viewBox: '0 0 1024 1024',
        data: (
            <Fragment>
                <path
                    fill="currentColor"
                    d="M512 42.667C253.3 42.667 42.667 253.3 42.667 512S253.3 981.333 512 981.333c258.7 0 469.333-210.633 469.333-469.333S770.7 42.667 512 42.667zM512 128c212.583 0 384 171.417 384 384S724.583 896 512 896 128 724.583 128 512s171.417-384 384-384z"
                />
                <path
                    fill="currentColor"
                    d="M511.333 468.75c-23.278.375-42.004 19.334-42.004 42.666 0 .205.001.411.004.615V512v170.667c-.003.179-.004.391-.004.603 0 23.567 19.104 42.671 42.671 42.671s42.671-19.104 42.671-42.671c0-.212-.002-.424-.005-.635v.032V512c.003-.174.004-.379.004-.584 0-23.567-19.104-42.671-42.671-42.671-.234 0-.468.002-.702.006h.035zM512 298.667a37.593 37.593 0 0 0-.603-.004c-23.567 0-42.671 19.104-42.671 42.671s19.104 42.671 42.671 42.671c.212 0 .424-.002.635-.005H512c.179.003.391.004.603.004 23.567 0 42.671-19.104 42.671-42.671s-19.104-42.671-42.671-42.671c-.212 0-.424.002-.635.005H512z"
                />
            </Fragment>
        )
    },
    LOADING: {
        viewBox: '0 0 32 32',
        data: (
            <g fill="#d4d4d4">
                <path
                    opacity=".25"
                    d="M16 0a16 16 0 0 0 0 32 16 16 0 0 0 0-32m0 4a12 12 0 0 1 0 24 12 12 0 0 1 0-24"
                />
                <path d="M16 0a16 16 0 0 1 16 16h-4A12 12 0 0 0 16 4z">
                    <animateTransform
                        attributeName="transform"
                        type="rotate"
                        from="0 16 16"
                        to="360 16 16"
                        dur="0.8s"
                        repeatCount="indefinite"
                    />
                </path>
            </g>
        )
    },
    NOTE: {
        viewBox: '0 0 108 133.5',
        data: (
            <Fragment>
                <path
                    fill="currentColor"
                    d="M82 0H0v133.5h108V27zm10.5 119h-76V16h59.7l16.3 16.5z"
                />
                <path
                    fill="currentColor"
                    d="M28.54 36.25h51.91v12.73H28.54zM28.54 63.32h51.91v12.73H28.54zM28.54 90.39h51.91v12.73H28.54z"
                />
            </Fragment>
        )
    },
    SQUARE: {
        viewBox: '0 0 1024 1024',
        data: (
            <Fragment>
                <path fill="none" d="M-1-1h582v402H-1z" />
                <path
                    fill="currentColor"
                    d="M128 85.333c-23.563.002-42.664 19.103-42.667 42.666v298.667c.002 23.563 19.103 42.664 42.666 42.667h298.667c23.563-.002 42.664-19.103 42.667-42.666V128c-.002-23.563-19.103-42.664-42.666-42.667H128zM597.333 85.333c-23.563.002-42.664 19.103-42.667 42.666v298.667c.002 23.563 19.103 42.664 42.666 42.667h298.667c23.563-.002 42.664-19.103 42.667-42.666V128c-.002-23.563-19.103-42.664-42.666-42.667H597.333zM597.333 554.667c-23.563.002-42.664 19.103-42.667 42.666V896c.002 23.563 19.103 42.664 42.666 42.667h298.667c23.563-.002 42.664-19.103 42.667-42.666V597.334c-.002-23.563-19.103-42.664-42.666-42.667H597.333zM128 554.667c-23.563.002-42.664 19.103-42.667 42.666V896c.002 23.563 19.103 42.664 42.666 42.667h298.667c23.563-.002 42.664-19.103 42.667-42.666V597.334c-.002-23.563-19.103-42.664-42.666-42.667H128z"
                />
            </Fragment>
        )
    },
    FORTNITE: {
        viewBox: '0 0 128 128',
        data: (
            <Fragment>
                <circle cx="64" cy="64" r="61" fill="white" />
                <path
                    fill="#761FA1"
                    d="M53.9.5c-.3.2-1.6.6-3 .8-5.5 1-11.7 3.3-16.2 5.9C32.1 8.7 29.5 10 29 10c-2.3 0-17 16-20.6 22.5-13.8 25.1-10 55.2 9.6 75.8 3.7 3.7 7.5 7.4 8.7 8 4.9 2.9 12.3 6.7 13 6.8.5 0 1.3.5 1.9 1 2.5 2.1 14.2 3.8 23.9 3.5 14.6-.5 18.1-1.4 28.4-7.1 2.9-1.7 6.4-3.6 7.7-4.3 5-2.8 15.5-15.6 19.4-23.6 5.5-11.6 6.9-18.1 6.6-31.1-.2-9.6-.7-12-3.4-19-1.8-4.4-5-10.8-7.2-14.2-8.4-12.8-24.3-24-38.2-26.8C74.9.7 54.5-.2 53.9.5zm31.7 20l-.7 4.5H111.6l-1.3 9.7c-1 7.8-1.1 14.7-.3 33.3.6 12.9 1.3 24.8 1.5 26.4l.5 2.8-17.3-.8c-9.4-.4-19-.8-21.1-.8l-3.9-.1-.1 5.5-.1 5.5-11 2.2c-6 1.2-12.2 2.4-13.7 2.7l-2.8.6v-6.5c0-7.6.9-7.3-15.5-5-5.4.8-10 1.3-10.1 1.2-.1-.1.3-12.2 1-26.8 1.1-24.1.9-33.6-.9-46.2L16 25h26v-9h44.2l-.6 4.5z"
                />
                <path
                    fill="#761FA1"
                    d="M46.4 20.9c-.2.2-.4 19.5-.4 42.8 0 33.2.3 42.3 1.3 42.3.6 0 4.7-.7 9-1.5s8.1-1.5 8.3-1.5c.2 0 .4-7.2.4-16V71h12V53H65V39h6.9c7.9 0 7.4.7 8.6-12l.6-6.5H64c-9.5 0-17.4.2-17.6.4z"
                />
            </Fragment>
        )
    }
};
